webpackJsonp([1],{

/***/ 1211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1220:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1222:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1224:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 490,
	"./af.js": 490,
	"./ar": 498,
	"./ar-dz": 491,
	"./ar-dz.js": 491,
	"./ar-kw": 492,
	"./ar-kw.js": 492,
	"./ar-ly": 493,
	"./ar-ly.js": 493,
	"./ar-ma": 494,
	"./ar-ma.js": 494,
	"./ar-ps": 495,
	"./ar-ps.js": 495,
	"./ar-sa": 496,
	"./ar-sa.js": 496,
	"./ar-tn": 497,
	"./ar-tn.js": 497,
	"./ar.js": 498,
	"./az": 499,
	"./az.js": 499,
	"./be": 500,
	"./be.js": 500,
	"./bg": 501,
	"./bg.js": 501,
	"./bm": 502,
	"./bm.js": 502,
	"./bn": 504,
	"./bn-bd": 503,
	"./bn-bd.js": 503,
	"./bn.js": 504,
	"./bo": 505,
	"./bo.js": 505,
	"./br": 506,
	"./br.js": 506,
	"./bs": 507,
	"./bs.js": 507,
	"./ca": 508,
	"./ca.js": 508,
	"./cs": 509,
	"./cs.js": 509,
	"./cv": 510,
	"./cv.js": 510,
	"./cy": 511,
	"./cy.js": 511,
	"./da": 512,
	"./da.js": 512,
	"./de": 515,
	"./de-at": 513,
	"./de-at.js": 513,
	"./de-ch": 514,
	"./de-ch.js": 514,
	"./de.js": 515,
	"./dv": 516,
	"./dv.js": 516,
	"./el": 517,
	"./el.js": 517,
	"./en-au": 518,
	"./en-au.js": 518,
	"./en-ca": 519,
	"./en-ca.js": 519,
	"./en-gb": 520,
	"./en-gb.js": 520,
	"./en-ie": 521,
	"./en-ie.js": 521,
	"./en-il": 522,
	"./en-il.js": 522,
	"./en-in": 523,
	"./en-in.js": 523,
	"./en-nz": 524,
	"./en-nz.js": 524,
	"./en-sg": 525,
	"./en-sg.js": 525,
	"./eo": 526,
	"./eo.js": 526,
	"./es": 530,
	"./es-do": 527,
	"./es-do.js": 527,
	"./es-mx": 528,
	"./es-mx.js": 528,
	"./es-us": 529,
	"./es-us.js": 529,
	"./es.js": 530,
	"./et": 531,
	"./et.js": 531,
	"./eu": 532,
	"./eu.js": 532,
	"./fa": 533,
	"./fa.js": 533,
	"./fi": 534,
	"./fi.js": 534,
	"./fil": 535,
	"./fil.js": 535,
	"./fo": 536,
	"./fo.js": 536,
	"./fr": 539,
	"./fr-ca": 537,
	"./fr-ca.js": 537,
	"./fr-ch": 538,
	"./fr-ch.js": 538,
	"./fr.js": 539,
	"./fy": 540,
	"./fy.js": 540,
	"./ga": 541,
	"./ga.js": 541,
	"./gd": 542,
	"./gd.js": 542,
	"./gl": 543,
	"./gl.js": 543,
	"./gom-deva": 544,
	"./gom-deva.js": 544,
	"./gom-latn": 545,
	"./gom-latn.js": 545,
	"./gu": 546,
	"./gu.js": 546,
	"./he": 547,
	"./he.js": 547,
	"./hi": 548,
	"./hi.js": 548,
	"./hr": 549,
	"./hr.js": 549,
	"./hu": 550,
	"./hu.js": 550,
	"./hy-am": 551,
	"./hy-am.js": 551,
	"./id": 552,
	"./id.js": 552,
	"./is": 553,
	"./is.js": 553,
	"./it": 555,
	"./it-ch": 554,
	"./it-ch.js": 554,
	"./it.js": 555,
	"./ja": 556,
	"./ja.js": 556,
	"./jv": 557,
	"./jv.js": 557,
	"./ka": 558,
	"./ka.js": 558,
	"./kk": 559,
	"./kk.js": 559,
	"./km": 560,
	"./km.js": 560,
	"./kn": 561,
	"./kn.js": 561,
	"./ko": 562,
	"./ko.js": 562,
	"./ku": 564,
	"./ku-kmr": 563,
	"./ku-kmr.js": 563,
	"./ku.js": 564,
	"./ky": 565,
	"./ky.js": 565,
	"./lb": 566,
	"./lb.js": 566,
	"./lo": 567,
	"./lo.js": 567,
	"./lt": 568,
	"./lt.js": 568,
	"./lv": 569,
	"./lv.js": 569,
	"./me": 570,
	"./me.js": 570,
	"./mi": 571,
	"./mi.js": 571,
	"./mk": 572,
	"./mk.js": 572,
	"./ml": 573,
	"./ml.js": 573,
	"./mn": 574,
	"./mn.js": 574,
	"./mr": 575,
	"./mr.js": 575,
	"./ms": 577,
	"./ms-my": 576,
	"./ms-my.js": 576,
	"./ms.js": 577,
	"./mt": 578,
	"./mt.js": 578,
	"./my": 579,
	"./my.js": 579,
	"./nb": 580,
	"./nb.js": 580,
	"./ne": 581,
	"./ne.js": 581,
	"./nl": 583,
	"./nl-be": 582,
	"./nl-be.js": 582,
	"./nl.js": 583,
	"./nn": 584,
	"./nn.js": 584,
	"./oc-lnc": 585,
	"./oc-lnc.js": 585,
	"./pa-in": 586,
	"./pa-in.js": 586,
	"./pl": 587,
	"./pl.js": 587,
	"./pt": 589,
	"./pt-br": 588,
	"./pt-br.js": 588,
	"./pt.js": 589,
	"./ro": 590,
	"./ro.js": 590,
	"./ru": 591,
	"./ru.js": 591,
	"./sd": 592,
	"./sd.js": 592,
	"./se": 593,
	"./se.js": 593,
	"./si": 594,
	"./si.js": 594,
	"./sk": 595,
	"./sk.js": 595,
	"./sl": 596,
	"./sl.js": 596,
	"./sq": 597,
	"./sq.js": 597,
	"./sr": 599,
	"./sr-cyrl": 598,
	"./sr-cyrl.js": 598,
	"./sr.js": 599,
	"./ss": 600,
	"./ss.js": 600,
	"./sv": 601,
	"./sv.js": 601,
	"./sw": 602,
	"./sw.js": 602,
	"./ta": 603,
	"./ta.js": 603,
	"./te": 604,
	"./te.js": 604,
	"./tet": 605,
	"./tet.js": 605,
	"./tg": 606,
	"./tg.js": 606,
	"./th": 607,
	"./th.js": 607,
	"./tk": 608,
	"./tk.js": 608,
	"./tl-ph": 609,
	"./tl-ph.js": 609,
	"./tlh": 610,
	"./tlh.js": 610,
	"./tr": 611,
	"./tr.js": 611,
	"./tzl": 612,
	"./tzl.js": 612,
	"./tzm": 614,
	"./tzm-latn": 613,
	"./tzm-latn.js": 613,
	"./tzm.js": 614,
	"./ug-cn": 615,
	"./ug-cn.js": 615,
	"./uk": 616,
	"./uk.js": 616,
	"./ur": 617,
	"./ur.js": 617,
	"./uz": 619,
	"./uz-latn": 618,
	"./uz-latn.js": 618,
	"./uz.js": 619,
	"./vi": 620,
	"./vi.js": 620,
	"./x-pseudo": 621,
	"./x-pseudo.js": 621,
	"./yo": 622,
	"./yo.js": 622,
	"./zh-cn": 623,
	"./zh-cn.js": 623,
	"./zh-hk": 624,
	"./zh-hk.js": 624,
	"./zh-mo": 625,
	"./zh-mo.js": 625,
	"./zh-tw": 626,
	"./zh-tw.js": 626
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1362;

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1212)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1221)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1225)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1224)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1216)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1219)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1215)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1222)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(1397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1217)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1218)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1228)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(1403),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1214)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1227)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1223)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1398),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1226)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.showHeaderAndFooter) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.showHeaderAndFooter) ? _c('bottom') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": _vm.$t('form_1')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "placeholder": _vm.$t('form_2')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "placeholder": _vm.$t('form_3')
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "id": "content",
      "placeholder": _vm.$t('form_4')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "right",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "color": "#f67c4f"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "5px 20px",
      "background": "#526193 !important",
      "border": "1px solid #526193"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('form_submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "mask"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "5px",
      "margin-top": "150px",
      "background": "white",
      "width": "250px",
      "margin-left": "calc((100% - 250px)/2)",
      "text-align": "center",
      "padding": "30px 15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "22px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('form_submitted')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#526193 !important",
      "border-radius": "25px",
      "border": "none",
      "padding": "5px 30px !important",
      "font-size": "14px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeMask()
      }
    }
  }, [_vm._v("OK")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('i', {
    staticClass: "bi bi-check-circle-fill",
    staticStyle: {
      "color": "#43b143",
      "font-size": "40px"
    }
  })])
}]}

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - PARTNER")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_2')) + "            ")]), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-partner.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - CONTACT")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_email')) + " cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-13917648345")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_mobile')) + "13917648345")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_2')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-533-7525879")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_fax')) + " 0086-533-7484168")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_3')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-21-58569507")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" " + _vm._s(_vm.$t('contact_fax')) + " 0086-21-58201568")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "margin-top": "20px"
    }
  }, [_c('contact')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })])
}]}

/***/ }),

/***/ 1391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#526193",
      "color": "white",
      "padding": "40px 0px",
      "text-align": "center",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "bottom-cate"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_4')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._v("Copyright @ 2022  ADA CHEMICALS")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [(_vm.authroized) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "orangered"
    }
  }, [_vm._v("来源1")]), _vm._v(" "), _vm._l((_vm.list), function(l) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(l)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "orangered"
    }
  }, [_vm._v("来源2")]), _vm._v(" "), _vm._l((_vm.list2), function(l) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(l)
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.authroized) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.viewList()
      }
    }
  }, [_vm._v("查看")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 order-md-2"
  }, [_c('div', {
    staticClass: "bc-video-player",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "preload": "metadata",
      "autoplay": "true",
      "muted": "",
      "id": "video",
      "poster": "/static/images/video.jpg",
      "playsinline": "",
      "webkit-playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "οncanplay": function($event) {
        return _vm.canplay()
      }
    }
  }, [_c('source', {
    attrs: {
      "src": "//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/317537464684.mp4"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('p', {
    staticClass: "header-text text-md-start",
    staticStyle: {
      "color": "#526193"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_title')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_desc_1')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('home_desc_2')) + "\n                    ")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "10px 20px",
      "background": "#526193 !important",
      "border": "1px solid #826e9e"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gotoUrl('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_view_detail')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#526193",
      "font-size": "24px",
      "font-weight": "bold",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4_detail')) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "40px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "50px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product')))]), _vm._v(" "), _c('div', {
    staticClass: "all-products"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2_detail')) + "\n\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4_detail')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "0px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_adv')))]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_1')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_1_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_2')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_2_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_3')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_3_detail')) + "            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-factory.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-production.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-rd.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-delivery.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
}]}

/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.categoryName))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#888",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [(_vm.category == '1') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '2') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('107')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_5')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('59')
      }
    }
  }, [_vm._v(" CPE 135A")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('63')
      }
    }
  }, [_vm._v("ACR")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('118')
      }
    }
  }, [_vm._v(" PVC  Resin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('60')
      }
    }
  }, [_vm._v(" PE wax")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('71')
      }
    }
  }, [_vm._v(" Optical brightener")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('96')
      }
    }
  }, [_vm._v(" Nano calcium carbonate")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '5') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('69')
      }
    }
  }, [_vm._v(" Sodium Acid Pyrophosphate SAPP")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('117')
      }
    }
  }, [_vm._v(" Purified Terephthalic Acid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('70')
      }
    }
  }, [_vm._v(" Dicyandiamide")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('108')
      }
    }
  }, [_vm._v(" Fumed Silica")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('106')
      }
    }
  }, [_vm._v(" silicon carbide abrasive")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('79')
      }
    }
  }, [_vm._v(" Poly Aluminium Chloride (PAC)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('56')
      }
    }
  }, [_vm._v(" Magnesium hydroxide")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('66')
      }
    }
  }, [_vm._v(" Barium Sulfate")])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product107_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product59_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product63_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product60_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product71_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product96_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product69_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product70_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product108_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product106_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product79_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product56_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product66_logo.png"
    }
  })])
}]}

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-title1"
  }, [_vm._v(_vm._s(_vm.$t('menu_product_left')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1",
    staticStyle: {
      "border-top": "1px solid #e2e6eb"
    }
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "background": "#e1e1e1",
      "padding-left": "15px",
      "height": "50px",
      "line-height": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading6"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('left_q_title')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#f1f1f1",
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_1')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_2')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_3')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_4')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    staticStyle: {
      "border": "none"
    },
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_5')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - COMPANY")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                ADA Chemical is a professional manufacture of chemical raw materials. Our sales and service center is in Shanghai, and our production base is located in Zibo City, Shandong Province, which is well-known as the supper-large chemical city in China.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            Established in 1995, we have more than 20 years 'experience in chemical industry. Now the company has an asset of over 30,000,000RMB, covers 10,000 square meters, and we have more than 120 employees now.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            After 20 years’ technology accumulation and market development, we are now dedicated in the following products:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\n                Aluminum hydroxide:  We are producing different particle size of ATH，our superfine model is up to 1um, the main applications are for flame retardant, solid surface, glass, alum, etc.")]), _c('li', [_vm._v("\n                PVC raw materials: We can supply full series of PVC materials, such as PVC Resin, PVC Stabilizer, CPE, blowing agent, lubricant, plasticizer, pigments, etc. Not only supply all these materials, we can also provide technical support for our customers during their production.")]), _c('li', [_vm._v("\n                Boron Nitride: Our Boron Nitride products are price competitive and high quality, we can provide both powders and coating. It is mainly used in precision molding, high temperature resistant, structural material, etc.")]), _c('li', [_vm._v("\n                Raw materials: Such as Purified Terephthalic acid (PTA), HPMC&CMC, HDPE&LDPE, Dicyandiamide, Melamine, etc.")]), _c('li', [_vm._v("\n                Food additives: Sodium bicarbonate, sodium acid pyrophosphate, ammonium bicarbonate, etc.")])]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                We believe that our factory direct prices will low down your cost and help you to grow your business. All staff of ADA Chemicals warmly welcome customers and friends all over the world.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-company.jpg"
    }
  })])
}]}

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - CUSTOMER")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer_1')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer_2')) + "\n            ")]), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            Pre-Sales service：\n            "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\nFree consulting service help you to find the most suitable material for your application.")]), _c('li', [_vm._v("\nProvide free sample for test and evaluation.")]), _c('li', [_vm._v("\nConsulting service through your testing process.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            After-Sales service：\n            "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\nFast delivery and strict quality inspection for every shipment.")]), _c('li', [_vm._v("\nVarious packing available upon customer’s requirement.")]), _c('li', [_vm._v("\nProfessional service for shipment and export process.")]), _c('li', [_vm._v("\nTechnical support through your manufacturing process.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-customer.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 1398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - SERVICE")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_2')) + "       \n            ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_1')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_1')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_2')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_2')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_3')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_3')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_4')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_4')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_5')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_5')) + "  ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/service.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 1399:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "order-header",
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("新建PI")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("筛选：")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "筛选PI类型",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选PI类型\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                    境外单\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                    境内单\n                ")])], 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "筛选PI类型",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleStatusChange
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选PI状态\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                    未结单\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                    已结单\n                ")])], 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "default-value": "lucy",
      "placeholder": "筛选国家地区",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选国家地区\n                ")]), _vm._v(" "), _vm._l((_vm.config.countries), function(c, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": c.code
      }
    }, [_vm._v("\n                    " + _vm._s(c.name) + " (" + _vm._s(c.code) + ")\n                ")])
  })], 2), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入客户名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleCustomerChange
    },
    model: {
      value: (_vm.selectedCustomer),
      callback: function($$v) {
        _vm.selectedCustomer = $$v
      },
      expression: "selectedCustomer"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入货代名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleFreightChange
    },
    model: {
      value: (_vm.selectedFreight),
      callback: function($$v) {
        _vm.selectedFreight = $$v
      },
      expression: "selectedFreight"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入产品名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleProductNameChange
    },
    model: {
      value: (_vm.selectedProductName),
      callback: function($$v) {
        _vm.selectedProductName = $$v
      },
      expression: "selectedProductName"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入PINo.以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handlePINoChange
    },
    model: {
      value: (_vm.selectedPINo),
      callback: function($$v) {
        _vm.selectedPINo = $$v
      },
      expression: "selectedPINo"
    }
  }), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("重置筛选条件")]), _vm._v(" "), _c('a-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.data,
      "size": "middle",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(type) {
        return _c('span', {}, [(type == 1) ? _c('a-tag', {
          attrs: {
            "color": "orange"
          }
        }, [_vm._v("\n          境外单\n        ")]) : _vm._e(), _vm._v(" "), (type == 2) ? _c('a-tag', {
          attrs: {
            "color": "geekblue"
          }
        }, [_vm._v("\n          境内单\n        ")]) : _vm._e()], 1)
      }
    }, {
      key: "status",
      fn: function(status) {
        return _c('span', {}, [(status == 1) ? _c('a-tag', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("\n          未结单\n        ")]) : _vm._e(), _vm._v(" "), (status == 2) ? _c('a-tag', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("\n          已结单\n        ")]) : _vm._e()], 1)
      }
    }, {
      key: "region",
      fn: function(region) {
        return _c('span', {}, [(_vm.config.countries) ? _c('span', [_vm._v(_vm._s(_vm.config.countries.find(function (t) { return t.code == region; }).name) + " ")]) : _vm._e(), _vm._v(" (" + _vm._s(region) + ")\n      ")])
      }
    }, {
      key: "firstProduct",
      fn: function(text, record) {
        return _c('span', {}, [(record.products && record.products.length > 0) ? _c('span', [_vm._v(_vm._s(record.products[0].productName) + " ")]) : _vm._e()])
      }
    }, {
      key: "firstProductCount",
      fn: function(text, record) {
        return _c('span', {}, [(record.products && record.products.length > 0) ? _c('span', [_vm._v(_vm._s(record.products[0].productCount) + " ")]) : _vm._e()])
      }
    }, {
      key: "dollarProfitTotal",
      fn: function(text, record) {
        return _c('span', {}, [(record.type == 1) ? _c('span', [_vm._v(_vm._s(record.profitTotal) + " ")]) : _vm._e(), _vm._v(" "), (record.type == 2) ? _c('span') : _vm._e()])
      }
    }, {
      key: "profitTotal",
      fn: function(text, record) {
        return _c('span', {}, [(record.type == 1) ? _c('span', [_vm._v(_vm._s((record.profitTotal * 7.1).toFixed(2)) + " ")]) : _vm._e(), _vm._v(" "), (record.type == 2) ? _c('span', [_vm._v(_vm._s(parseFloat(record.profitTotal).toFixed(2)) + " ")]) : _vm._e()])
      }
    }, {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.edit(record)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('a-divider', {
          attrs: {
            "type": "vertical"
          }
        }), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteOrder(record)
            }
          }
        }, [_vm._v("删除")])], 1)
      }
    }])
  }), _vm._v(" "), (_vm.data.length > 0 && _vm.summary != null) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("产品: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProductCount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("合同金额: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProductPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("实收: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalIncome.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("采购: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProcument.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("物流: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalShipping.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("佣金: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalBrokerage.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("其他: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalOther.toFixed(2)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticClass: "total-item"
  }, [_vm._v("利润: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProfit.toFixed(2)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticClass: "total-item"
  }, [_vm._v("利润率: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s((_vm.summary.totalProfitRate * 100).toFixed(2)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "overflow": "hidden"
    }
  }, [_c('a-pagination', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "show-total": function (total) { return ("共 " + total + " 条"); },
      "total": _vm.total,
      "show-quick-jumper": "",
      "pageSize": _vm.pageSize
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pageNumber),
      callback: function($$v) {
        _vm.pageNumber = $$v
      },
      expression: "pageNumber"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(" 每页 "), _c('a-select', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "default-value": "lucy"
    },
    on: {
      "change": _vm.changePageSize
    },
    model: {
      value: (_vm.pageSize),
      callback: function($$v) {
        _vm.pageSize = $$v
      },
      expression: "pageSize"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("\n                    10\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("\n                    15\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("\n                    20\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("\n                    30\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("\n                    50\n                ")])], 1), _vm._v(" 条\n        ")], 1)], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": _vm.mode == 'create' ? '创建PI' : '编辑PI',
      "ok-text": "保存PI信息",
      "cancel-text": "取消",
      "width": "1200px"
    },
    on: {
      "ok": _vm.submitCreateModal
    },
    model: {
      value: (_vm.createModal),
      callback: function($$v) {
        _vm.createModal = $$v
      },
      expression: "createModal"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "合同编号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.form.orderPre) + " "), _c('a-input', {
    staticStyle: {
      "width": "60px"
    },
    model: {
      value: (_vm.form.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderNo", $$v)
      },
      expression: "form.orderNo"
    }
  }), _vm._v(" " + _vm._s(_vm.form.orderPost) + "\n                    ")], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "合同类型"
    }
  }, [_c('a-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                            境外单\n                            ")]), _vm._v(" "), _c('a-radio', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                            境内单\n                            ")])], 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('a-radio-group', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                            未结单\n                            ")]), _vm._v(" "), _c('a-radio', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                            已结单\n                            ")])], 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "提单日(ETD)"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.etd),
      callback: function($$v) {
        _vm.$set(_vm.form, "etd", $$v)
      },
      expression: "form.etd"
    }
  })], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "到港日(ETA)"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.eta),
      callback: function($$v) {
        _vm.$set(_vm.form, "eta", $$v)
      },
      expression: "form.eta"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('a-form-model', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "国家简称"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "选择国家简称"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, _vm._l((_vm.config.countries), function(c, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": c.code
      }
    }, [_vm._v("\n                            " + _vm._s(c.name) + " (" + _vm._s(c.code) + ")\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "客户名称"
    }
  }, [_c('a-input', {
    model: {
      value: (_vm.form.customer),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer", $$v)
      },
      expression: "form.customer"
    }
  })], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "销售人员"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "选择销售人员"
    },
    model: {
      value: (_vm.form.sales),
      callback: function($$v) {
        _vm.$set(_vm.form, "sales", $$v)
      },
      expression: "form.sales"
    }
  }, _vm._l((_vm.config.sales), function(sale, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": sale
      }
    }, [_vm._v("\n                            " + _vm._s(sale) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "佣金汇总"
    }
  }, [_c('a-input-number', {
    model: {
      value: (_vm.form.brokerage),
      callback: function($$v) {
        _vm.$set(_vm.form, "brokerage", $$v)
      },
      expression: "form.brokerage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.productColumns,
      "dataSource": _vm.products,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.productNumberColumns), function(temp) {
      return {
        key: temp,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProductChange(e, record.key, temp); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.productEditableColumns), function(temp1) {
      return {
        key: temp1,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProductChange(e.target.value, record.key, temp1); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.productFixedColumns), function(s) {
      return {
        key: s,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record, index) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProduct(index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.products.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("数量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProductTotal().count))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProductTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加产品")], 1)], 1)], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a-tabs', {
    attrs: {
      "default-active-key": "2",
      "tab-position": "top",
      "type": "card"
    }
  }, [_c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "采购"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.procumentColumns,
      "dataSource": _vm.procuments,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.procumentNumberColumns), function(temp3) {
      return {
        key: temp3,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProcumentChange(e, record.key, temp3); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.procumentEditableColumns), function(temp4) {
      return {
        key: temp4,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProcumentChange(e.target.value, record.key, temp4); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.procumentFixedColumns), function(temp5) {
      return {
        key: temp5,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProcument(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.procuments.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终采购成本总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProcumentTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProcument
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加采购")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "3",
    attrs: {
      "tab": "物流"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.shippingColumns,
      "dataSource": _vm.shippings,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.shippingNumberColumns), function(temp6) {
      return {
        key: temp6,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            staticStyle: {
              "width": "70px"
            },
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleShippingChange(e, record.key, temp6); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.shippingEditableColumns), function(temp7) {
      return {
        key: temp7,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleShippingChange(e.target.value, record.key, temp7); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.shippingFixedColumns), function(temp8) {
      return {
        key: temp8,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteShipping(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.shippings.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终物流总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getShippingTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addShipping
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加物流")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "4",
    attrs: {
      "tab": "银行费用"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.bankCostColumns,
      "dataSource": _vm.bankcosts,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.bankcostNumberColumns), function(temp10) {
      return {
        key: temp10,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleBankcostChange(e, record.key, temp10); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.bankcostEditableColumns), function(temp11) {
      return {
        key: temp11,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleBankcostChange(e.target.value, record.key, temp11); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.bankcostFixedColumns), function(temp12) {
      return {
        key: temp12,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "actualIncomeDate",
      fn: function(text, record, index) {
        return [(record.mode == 'edit') ? _c('a-date-picker', {
          attrs: {
            "value": record.actualIncomeDate,
            "type": "date",
            "placeholder": "选择日期"
          },
          on: {
            "change": function (e) { return _vm.handleDateChange(e, record.key); }
          }
        }) : _c('span', [_vm._v(_vm._s(record.actualIncomeDate.format('yyyy-MM-DD')))])]
      }
    }, {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBankcost(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.bankcosts.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终实收总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getBankTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBankcost
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加银行费用")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "5",
    attrs: {
      "tab": "其他费用"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.otherColumns,
      "dataSource": _vm.others,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.otherNumberColumns), function(temp13) {
      return {
        key: temp13,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleOtherChange(e, record.key, temp13); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.otherEditableColumns), function(temp14) {
      return {
        key: temp14,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleOtherChange(e.target.value, record.key, temp14); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.otherFixedColumns), function(temp15) {
      return {
        key: temp15,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteOther(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.others.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("其他费用总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getOtherTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOther
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加其他费用")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1400:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticStyle: {
      "margin-top": "50px",
      "margin-bottom": "40px",
      "text-align": "center"
    }
  }, [_vm._v("\n        ADA 订单管理\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "margin": "auto"
    }
  }, [_c('a-form', {
    staticClass: "login-form",
    attrs: {
      "id": "components-form-demo-normal-login",
      "form": _vm.form
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'userName',
        {
          rules: [{
            required: true,
            message: 'Please input your username!'
          }]
        } ]),
      expression: "[\n            'userName',\n            { rules: [{ required: true, message: 'Please input your username!' }] },\n          ]"
    }],
    attrs: {
      "placeholder": "请输入登录名"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'password',
        {
          rules: [{
            required: true,
            message: 'Please input your Password!'
          }]
        } ]),
      expression: "[\n            'password',\n            { rules: [{ required: true, message: 'Please input your Password!' }] },\n          ]"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', [_c('a-button', {
    staticClass: "login-form-button",
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("\n          登录\n        ")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1401:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - TEAM")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('team_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('team_2')) + "             ")]), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-team.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 1402:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '114') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '115' || _vm.id == '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '1141' && _vm.id != '1140' && _vm.id != '117' && _vm.id != '114' && _vm.id != '118' && _vm.id != '115' && _vm.id != '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_logo.png'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "text-primary",
    staticStyle: {
      "color": "#526193 !important"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("21645-51-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("281830000")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_6')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_10')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_7')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("70-120 ℃")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_9')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("38123090")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_5')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BN")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("10043-11-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2850001900")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(13)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(16)]) : _vm._e()])])]), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '115' && _vm.id != '57') ? _c('div', {
    staticClass: "product-sub",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.id == '1140') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(19)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(20)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(22)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(23)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(28)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(30)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(31)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(32)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(33)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(34)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Properties\n                ")]), _vm._v(" "), (_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_vm._m(35), _vm._v(" "), _c('p', [_vm._v("With 20 years production experience, now ADA Aluminum Hydroxide products have stable and high standard quality, with super fine particle size up to 1um, high whiteness up to 97, and also with low impurities. Now our ATH chemicals are exporting to more than 20 countries, and widely used in all kinds of industrial applications, such as fire retardants, artificial marbles, water treatment, and so on.\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Dicyandiamide is a kind of white crystal powder,which is soluble in water and alcohol, slightly insoluble in aether and benzene, stable when dry and not flammable.")]), _vm._v(" "), _c('p', [_vm._v("It is a material of melamine and intermediate pan of syntheticdrug,pesticides and coloring agent. It can be produced guanidine nitrate,sulfanilamide,sulfocarbanide,rubber accelerator,hardening of stell,fixing agent of dyeprinting,sizing agent,compound fertilizer,etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Sodium acid pyrophosphate, or disodium pyrophosphate, is an edible phosphoric salt that helps create leavening used for baking, such as baking powder, and prevents food discoloration, such as in raw potatoes.")]), _vm._v(" "), _c('p', [_vm._v("In its bulk state, such as at the manufacturing laboratory, the acidic nature of sodium acid pyrophosphate may be very hazardous upon skin or eye contact, inhalation or ingestion, causing severe inflammation.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Black Silicon Carbide, also know as Black SiC, is produced in an electric resistance furnace from quartz sand and petroleum coke or anthracite at high temperature. The hardness and sharp particle of this material make it suitable for manufacturing of grinding wheels, coated products, wire saws, superior refractory materials and deoxide as well as for lapping, polishing and blasting.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Silicon Carbide, and we are producing different grade of Silicon Carbide for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Hexagonal Boron Nitride is a thermally and chemically resistant refractory compound of boron and nitrogen with the chemical formula BN. The material is anisotropic for its electrical and mechanical properties due to the platy hexagonal crystals and their orientation during the hot press consolidation.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Boron Nitride has high thermal conductivity, low thermal expansion, good thermal shock resistance, high electrical resistance, low dielectric constant and loss tangent.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is an organic compound and is the most prolific dicarboxylic acid. Solid at room temperature. Heating will not melt, 300℃ above sublimation. If heated in an airtight container, it melts at 427℃. Terephthalic acid is the raw material for the production of polyesters, especially polyethylene terephthalate (PET).")]), _vm._v(" "), _c('p', [_vm._v("We are professional provider of PTA materials, and our sales specialist will recommend the most suitable material for your application, and related Technical Data Sheet is available upon your request.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Azodicarbonamide blowing agent is a kind of light yellow fine powder, which is one of the most widely used chemical blowing agents due to its non-toxic, odorless, self-extinguishing, relatively high decomposition temperature, and relatively large gas evolution properties, good dispersing in plastic and rubber.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Barium sulfate is a kind of amorphous white powder or paste. It is nontoxic, insoluble in water, and slightly soluble in boiling hydrochloric acid.")]), _vm._v(" "), _c('p', [_vm._v("It is chemically stable, with a total reduction of carbon as barium sulfide. It won't change color when meeting with hydrogen sulfide or toxic gases in the air.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is produced by the spray drying technology and the obtained product is light yellow, corresponding liquid form products is light yellow.")]), _vm._v(" "), _c('p', [_vm._v("It is a kind of high-efficient,economical and nontoxic inorganic high-molecular compound, which is easily soluble in water. And it's accompanied with many chemical processes such as electrochemistry,coagulation, absorption and precipitation during the hydrolyzation .")])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Magnesium hydroxide is a white powder which is nontoxic, odorless, non-corrosion and with good flame retarding effect. It has good stability, decomposition temperature is about 330, especially suitable for resin processed in relative high temperature. Large amount of vapor is produced during combustion, the heat is taken away and the temperature drops. The hardness is less than that of aluminum hydroxide.")]), _vm._v(" "), _c('p', [_vm._v("According to different applications, we are offering a wide range types of magnesium hydroxide, with different particle size\\whiteness, and we can also offer natural grade or coated types as requested.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is a protection coating material used in metal casting equipment and equipment molds, which has good adhesion ability for metal or ceramic materials, and to provide the most effective lubrication and protection of the interface.")]), _vm._v(" "), _c('p', [_vm._v("Boron Nitride Coating is made by boron nitride materials by unique formula, which can achieve excellent performance in high temperature metal protection, effectively prevent the molten metal from corrosion, extend the service life of equipment and various tools, reduce the production cost.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Boron Nitride coating materials, and we are producing different grade of products for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Nano calcium carbonate is also called super fine calcium carbonate .It can provide some excellent functions during polymer production such as improving the hardness of the polymer, improving strength (tensile and impact) and enhancing the surface whiteness and gloss finish.")]), _vm._v(" "), _c('p', [_vm._v("At the same time, it can also greatly reduce the cost during the production of plastic and rubber products.")]), _vm._v(" "), _c('p', [_vm._v("With it's outstanding functions, nano calcium carbonate is widely used in plastics product such as cable, pipe, masterbatch, film, sheet, etc. And also used in Paint & coating,paper, water treatment, etc.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Nano calcium carbonate powders, and we are producing different grade of Nano calcium carbonate for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Fumed silica is an extremely small particle with enormous surface area, high purity, and a tendency to form chains in the chemical manufacturing process.")]), _vm._v(" "), _c('p', [_vm._v("Particles are formed by injecting chlorosilanes, such as silicon tetrachloride, into a flame of hydrogen and air. The ensuring reaction produces fumed silica and hydrogen chloride.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is white powder, and the particle size is 60-250um. It is fire retardant and self-extinguishing, with very good chemical resistance.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("It is mainly used to produce soft plastic products such as artificial leather, films, and wire sheaths, as well as hard plastic products such as plates, doors and windows, pipes and valves.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Polyethylene wax is a widely used raw materials which has low adhesive, high softening point and good hardness with stable chemical characteristics.")]), _vm._v(" "), _c('p', [_vm._v("It also has good heat stability, good dispersion performance, no poison, no frost and mucous membrane.")]), _vm._v(" "), _c('p', [_vm._v("With all the above featues, it can be used as an ideal interior & exterior lubricant, and also as a substitute for liquid paraffin, natural paraffin etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Optical Brightener is a kind of light yellow powder, it is hardly soluble in water, but soluble in paraffin, mineral oils and ordinary organic solvents.")]), _vm._v(" "), _c('p', [_vm._v("There are different grade of optical brighteners such as OB grade/OB-1 grade/KSN grade /etc, each type of optical brightener can be used as good whitening agent for various application products such as plastic products, paintings, paper and textiles.\n\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("CPE resin is one kind of rubber high molecular material made of high-density polythene resin after chlorination reaction, which has good mechanical and chemical properties.")]), _vm._v(" "), _c('p', [_vm._v("It is widely used in PVC plastic profile, sheet, pipe, pipe fittings, waterproof membrane, wire and cable sheathing, sealing, PVC laminated and extension of various plastics and rubber products.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("ADA PVC Stabilizers are combinations of chemical additives necessary for the production of various PVC products. The stabilizer is Lead or Ca-Zn based, and also combined with lubricants and other additives, which can achieve ideal performance both for production and final products.\n             ")]), _vm._v(" "), _c('p', [_vm._v("ADA provides different models of stabilizers for applications such as: Pipes & Fittings, Wires & Cables, Window Profiles, Flooring and Films. Please contact our sales staff, we will give more product information according to your specific technical requirements.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Calcium Stearate is a kind of white fine powder, which is insoluble in water, soluble in hot ethanol and ether. It is easy to absorb, and will be decomposed to stearic acid and the relevant calcium-salt.")]), _vm._v(" "), _c('p', [_vm._v("It is mainly performed as a good kind of PVC lubricant, and widely used in PP and PVC products.")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Main Applications")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Technical Details")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '1140' && _vm.id != '57' && _vm.id != '115' && _vm.id != '114' && _vm.id != '1142' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_1.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(38), _vm._v(" "), _vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(40), _vm._v(" "), _vm._m(41)]) : _vm._e(), _vm._v(" "), (_vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Packing & Delivery\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '114' && _vm.id != '1140' && _vm.id != '115' && _vm.id != '1142' && _vm.id != '57' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_2.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(42), _vm._v(" "), _vm._m(43)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right_2.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(46), _vm._v(" "), _vm._m(47)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Product Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(48), _vm._v(" "), _vm._m(49)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Support\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(50), _vm._v(" "), _vm._m(51)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    One-Stop Provider\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(52), _vm._v(" "), _vm._m(53)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(54), _vm._v(" "), _vm._m(55)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Particle Distribution\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(56), _vm._v(" "), _vm._m(57)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Main Applications\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(58), _vm._v(" "), _vm._m(59)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Sales Contact\n                ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(60), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "font-size": "13px !important"
    }
  }, [_c('contact', {
    attrs: {
      "productName": _vm.name
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Al(OH)"), _c('sub', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Mg(oh)2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1309-48-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("96% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BaSO4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7727-43-7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2833270000")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4O2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("123-77-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Pale yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CH2-CHCLn")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-86-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("39041000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C8H6O4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-21-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("202-830-0")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiO2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("112945-52-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White Powder ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.8%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("461-58-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("207-312-8")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White crystal powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[AL2(OH)LnCL6-n]m")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1327-41-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("215-477-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Yellow powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[CH2-CHCl-CH2-CH2]n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("63231-66-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Na2H2P2O7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7758-16-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("231-835-0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Boron Nitride Coating")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Packing:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Barrels")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White emulsion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Solid content: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("25% ~ 30%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Silicon Carbide")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiC")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Granula")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Application: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Abrasive")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("(C2H4)n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-88-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White flake")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Softening Point (℃): ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-110")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C36H70O4Ca")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1592-23-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("471-34-1")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CACO3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Melting point: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("205-360°C")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Particle size:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("300 meshes Min")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Light yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content（%）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size（D50）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture（%）")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Fine Grade")]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("1-2 um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("3-5 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("8-10 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("High Whiteness")]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("14 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("25 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("50 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("75 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Normal Grade")]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('strong', [_vm._v("Fine Grade")])]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("1-2um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("3-5um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("8-10um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_c('strong', [_vm._v("High Whiteness")])]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("14um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("25um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("50um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("75um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("Normal Grade")])]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mg(OH)2 , %")]), _c('td', [_vm._v("≥94")]), _c('td', [_vm._v("96.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size")]), _c('td', [_vm._v("325-8000 Mesh")]), _c('td', [_vm._v("325-8000 Mesh")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v("≥91")]), _c('td', [_vm._v("93")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("CaO , %")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Hydrochloric acid insoluble，% ")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture，%")]), _c('td', [_vm._v("≤ 0.5")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cl， %")]), _c('td', [_vm._v("≤ 0.05")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe， %")]), _c('td', [_vm._v("≤ 1.0")]), _c('td', [_vm._v("0.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("75um Residue, %")]), _c('td', [_vm._v("≤ 0.01")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Loss on ignition，%")]), _c('td', [_vm._v("≥28")]), _c('td', [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Modification Rate, %")]), _c('td', [_vm._v("≥98")]), _c('td', [_vm._v("99.5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Black granular")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Hardness, Mohs")]), _c('td', [_vm._v(">6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Apparent density ,kg/M3")]), _c('td', [_vm._v("3.2 x 10³")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("0.01")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("SiO2,%")]), _c('td', [_vm._v("28")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Al2O3,%")]), _c('td', [_vm._v("9.29")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Fe2O3,%")]), _c('td', [_vm._v("22.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("MgO,%")]), _c('td', [_vm._v("4.62")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C")]), _c('td', [_vm._v("16.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size (Mesh)")]), _c('td', [_vm._v("10-20, 20-40, 20-60, or as customer required")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Main ingredients")]), _c('td', [_vm._v("Hexagonal boron nitride")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Coverage area")]), _c('td', [_vm._v("25-30m2/L")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Adhesive")]), _c('td', [_vm._v("Clay")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity")]), _c('td', [_vm._v("4000-5000CPS")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Specific gravity")]), _c('td', [_vm._v("1.2(g/㎝3)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solid content")]), _c('td', [_vm._v("25%~30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White emulsion")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Chlorine content, %")]), _c('td', [_vm._v("35±2")]), _c('td', [_vm._v("35.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of fusion, j/g")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatile matter %")]), _c('td', [_vm._v("≤0.4")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Residue on sieve (mesh of 0.9mm)  %")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("0.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Impurity particles, pc/100g")]), _c('td', [_vm._v("≤60")]), _c('td', [_vm._v("21")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tensile strength, Mpa")]), _c('td', [_vm._v("≥8.0")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Shore hardness")]), _c('td', [_vm._v("≤65")]), _c('td', [_vm._v("52")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White flake")]), _c('td', [_vm._v("White flake")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Softening point ℃")]), _c('td', [_vm._v("90-105")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dosage (%)")]), _c('td'), _c('td', [_vm._v("3.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Density (g/cm3)")]), _c('td', [_vm._v("0.90-0.93")]), _c('td', [_vm._v("0.91")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average molecular weight")]), _c('td', [_vm._v("2000-2500")]), _c('td', [_vm._v("2320")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("calcium carbonate,%")]), _c('td', [_vm._v("≥ 98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value")]), _c('td', [_vm._v("8.0-10.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("≤0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v(" ≥ 96")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size")]), _c('td', [_vm._v("20-110 nm")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe content, %")]), _c('td', [_vm._v("≤0.08")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mn content, %    ")]), _c('td', [_vm._v(" ≤0.006")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Surface treatment")]), _c('td', [_vm._v("stearic acid")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Oil absorption ml/100g ")]), _c('td', [_vm._v("≤35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("E (1% /cm)         ")]), _c('td', [_vm._v("420-1200")]), _c('td', [_vm._v("420-1200(Depends on grade)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Indissoluble substance:       ")]), _c('td', [_vm._v("0.5%max")]), _c('td', [_vm._v("0.35")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water (25℃, g/l )")]), _c('td', [_vm._v("20-30")]), _c('td', [_vm._v("25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solubility in water   (70℃, g/l )")]), _c('td', [_vm._v("90-110")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water ( (95℃, g/l ))")]), _c('td', [_vm._v("290-310")]), _c('td', [_vm._v("300")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Max in ultra-violet range")]), _c('td', [_vm._v("348-350nm")]), _c('td', [_vm._v("349 nm")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standards")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("≥98.0%")]), _c('td', [_vm._v("0.982")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water soluble matter")]), _c('td', [_vm._v("≤0.30%")]), _c('td', [_vm._v("0.0011")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Acid soluble matter")]), _c('td', [_vm._v("≤0.60%")]), _c('td', [_vm._v("confirmed")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value  ")]), _c('td', [_vm._v("6.0-9.0")]), _c('td', [_vm._v("8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Iron(Fe)")]), _c('td', [_vm._v("≤0.004%")]), _c('td', [_vm._v("4E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Sulfide(S)")]), _c('td', [_vm._v("≤0.003%")]), _c('td', [_vm._v("1.5E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size distribution")]), _c('td', [_vm._v("Depends on grade")]), _c('td', [_vm._v("Depends on grade")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Oil absorption")]), _c('td', [_vm._v("8-25%")]), _c('td', [_vm._v("0.19")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness ")]), _c('td', [_vm._v("≥96")]), _c('td', [_vm._v("96")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Silica content(based on ignited material) ,wt%")]), _c('td', [_vm._v(">99.8%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Specific surface area (BET), m2/g   ")]), _c('td', [_vm._v("200+-15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Carbon content(Based on drying at 105℃ for 2 hours) ,wt%")]), _c('td', [_vm._v("<0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH-value in 4% dispersion")]), _c('td', [_vm._v("3.7-4.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture loss on drying 2 hour at 105℃, wt%")]), _c('td', [_vm._v("<1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Ignition loss 2 hours at 1000℃ based on material dried for 2 hours at 105℃, wt%")]), _c('td', [_vm._v("<2.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sieve residue(45um), wt%")]), _c('td', [_vm._v("<0.04")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tamped Density(Based on drying at 105℃ for 2 hours) ,g/L")]), _c('td', [_vm._v("40-60")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C2H4N4 Content, %")]), _c('td', [_vm._v("≥99.5")]), _c('td', [_vm._v("99.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("H2O Content, %")]), _c('td', [_vm._v("≤0.30")]), _c('td', [_vm._v("0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash Content, %")]), _c('td', [_vm._v("≤0.03")]), _c('td', [_vm._v("0.024")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("M.P. (°C)")]), _c('td', [_vm._v("209-212")]), _c('td', [_vm._v("210")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ca Content (ppm)")]), _c('td', [_vm._v("≤200")]), _c('td', [_vm._v("95")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Yellow powder")]), _c('td', [_vm._v("Yellow powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Gas of foaming amount(ML/G)")]), _c('td', [_vm._v("150-240")]), _c('td', [_vm._v("150-240")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average diameter(um)")]), _c('td', [_vm._v("8.5-10")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Decomposition temperature,")]), _c('td', [_vm._v("150-220")]), _c('td', [_vm._v("150-220")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture content(%)")]), _c('td', [_vm._v("0.5 max")]), _c('td', [_vm._v("0.12")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH")]), _c('td'), _c('td', [_vm._v("6.7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash(%)")]), _c('td', [_vm._v("0.2 max")]), _c('td', [_vm._v("0.09")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Specification")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White Powder")]), _c('td', [_vm._v("White Powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Content, %")]), _c('td', [_vm._v("≥95")]), _c('td', [_vm._v("95.33")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH of 1% water solution")]), _c('td', [_vm._v("3.5-5")]), _c('td', [_vm._v("3.98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble, %")]), _c('td', [_vm._v("≤1.0")]), _c('td', [_vm._v("0.03")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Pb, %")]), _c('td', [_vm._v("≤0.0015")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("As, %")]), _c('td', [_vm._v("≤0.0003")]), _c('td', [_vm._v("0.00018")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("F, %")]), _c('td', [_vm._v("≤0.005")]), _c('td', [_vm._v("0.002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("P2O5, %")]), _c('td'), _c('td', [_vm._v("63.57")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dryingloss %≤")]), _c('td'), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Bulk density")]), _c('td'), _c('td', [_vm._v("0.85")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Suspension Grade")]), _vm._v(" "), _c('td', [_vm._v("SG3")]), _vm._v(" "), _c('td', [_vm._v("SG4")]), _vm._v(" "), _c('td', [_vm._v("SG5")]), _vm._v(" "), _c('td', [_vm._v("SG6")]), _vm._v(" "), _c('td', [_vm._v("SG7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("K value ")]), _c('td', [_vm._v("72-71")]), _c('td', [_vm._v("70-69")]), _c('td', [_vm._v("68-66")]), _c('td', [_vm._v("65-63")]), _c('td', [_vm._v("62-60")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity, ml/g ")]), _c('td', [_vm._v("135-127")]), _c('td', [_vm._v("126-119")]), _c('td', [_vm._v("118-107")]), _c('td', [_vm._v("106-96")]), _c('td', [_vm._v("95-87")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average polymerization")]), _c('td', [_vm._v("1350-1250")]), _c('td', [_vm._v("1250-1150")]), _c('td', [_vm._v("1100-1000")]), _c('td', [_vm._v("950-850")]), _c('td', [_vm._v("950-850")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Number of impurity particle ≤")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 40")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatiles content %, ≤")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Spontaneous ignition point")]), _c('td', [_vm._v("680℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Burning point")]), _c('td', [_vm._v("384~421℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sublimation fever")]), _c('td', [_vm._v("98.4kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of combustion")]), _c('td', [_vm._v("3225.9kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Density")]), _c('td', [_vm._v("1.55g/cm3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Calcium content, %")]), _c('td', [_vm._v("6.0-7.1")]), _c('td', [_vm._v("6.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture, %")]), _c('td', [_vm._v("3max")]), _c('td', [_vm._v("2.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Melting Point,°C")]), _c('td', [_vm._v("140 min")]), _c('td', [_vm._v("147")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fineness (through mesh200), %")]), _c('td', [_vm._v("95min")]), _c('td', [_vm._v("98.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Free fatty acid, %")]), _c('td', [_vm._v("0.5 Max")]), _c('td', [_vm._v("0.4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Items")]), _c('td', [_vm._v("Specifications")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Aluminium oxide(Al2O3) % ")]), _c('td', [_vm._v("30%min")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Basicity%")]), _c('td', [_vm._v("70-90%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH (1% aqueous solution)")]), _c('td', [_vm._v("3.5-5.0%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble %")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("(As)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("(Pb)/%")]), _c('td', [_vm._v("≤0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cd(Cd)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Cr+6 %")]), _c('td', [_vm._v("≤0.0005")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("   Hg %")]), _c('td', [_vm._v("≤0.00001")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Aluminum Hydroxide, Al(OH)"), _c('sub', [_vm._v("3")]), _vm._v(" ,also called alumina trihydrate. It has both basic and acidic properties, and closely related are aluminum oxide or alumina (Al"), _c('sub', [_vm._v("2")]), _vm._v("O"), _c('sub', [_vm._v("3")]), _vm._v("), It can be heated to 200°C and hydrated alumina can be decomposed into 66% alumina and 34% water.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Flame Retardant")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as flame retardant filler for PVC and Rubber products, such as wire, cable, construction material, paint, etc.\n                            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Artificial Marble Filler")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as fillers for the production of Artificial Marble, Solid Surface, Stone, etc.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Raw Material")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as the raw material for the production of Alum, Glass, Water Treatment, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Packing")]), _vm._v(" "), _c('p'), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("25kg,  50kg, 1000Kg bags")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("OEM packing service available")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("One 20ft container can load")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 14 Tons (Super fine grade)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 24 Tons (Other grades)")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Shipment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Fast production and delivery.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Professional worldwide shipment")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 order-md-2",
    staticStyle: {
      "font-size": "15px",
      "line-height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                      cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-telephone-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                     +86-13917648345 "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("(WhatsApp/WeChat)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-geo-alt-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" Room 1208, No.36, 1200 Changqing Road, "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-5px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "23px"
    }
  }, [_vm._v("Pudong New Area, Shanghai")])])])])
}]}

/***/ }),

/***/ 1403:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-white",
    staticStyle: {
      "box-shadow": "2px 2px 5px #ccc"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    staticStyle: {
      "justify-content": "right",
      "position": "relative",
      "top": "15px"
    },
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "-30px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" cliff@adachemicals.com\n          \n            "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/en.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "3px"
    },
    attrs: {
      "src": "/static/images/zh.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh')
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav ms-auto"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarLandings"
    },
    on: {
      "click": function($event) {
        return _vm.jump('/')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_home')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "aboutUsMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_about')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "aboutUsMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_company')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('team')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_team')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('customer')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_customer')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('partner')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_partner')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "productMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_product')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "productMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_1')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_2')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_3')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('service')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_service')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('contactus')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_contact')) + "\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "navbar-brand-img",
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "id": "menuButton",
      "type": "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),

/***/ 1406:
/***/ (function(module, exports) {

module.exports = {"menu_home":"HOME","menu_about":"ABOUT US","menu_about_company":"Company","menu_about_team":"Team","menu_about_customer":"Customer","menu_about_partner":"Partner","menu_product":"PRODUCT","menu_product_1":"Aluminium Hydroxide","menu_product_2":"Boron Nitride","menu_product_3":"PVC Additives","menu_product_4":"Raw Materials","menu_service":"SERVICE","menu_contact":"CONTACT","menu_product_left":"Product Category","left_q_title":"FAQs","left_q_1":"Can I get a sample?","left_q_2":"What is the MOQ?","left_q_3":"About technical support","left_q_4":"About payment","left_q_5":"About OEM service","home_title":"Welcome to ADA CHEMICALS","home_desc_1":"ADA Chemical is a professional manufacture of chemical raw materials. Our sales and service center is in shanghai, and our production base is located in Zibo City, Shandong Province. It is south of Qilu Petrochemical Corporation, which is well-known as the supper-large chemical city in China.","home_desc_2":"Established in 1995, we have more than 20 years’experience in chemical raw material industry. Now the company has an asset of over 50,000,000RMB, covers 10,000 square meters, and we have more than 120 employees now","home_view_detail":"View Detail","home_about_section_1":"Factory","home_about_section_1_detail":"Covers 10,000 square meters，located in large chemical city.","home_about_section_2":"Production","home_about_section_2_detail":"Dedicated manufacturer, five independent production line.","home_about_section_3":"R&D","home_about_section_3_detail":"Professional and experienced staff, we are chemical people.","home_about_section_4":"Quality","home_about_section_4_detail":"Fast delivery and strict quality inspection for every shipment.","home_product":"Main Product","home_product_section_1":"Aluminium Hydroxide","home_product_section_1_detail":"Different particle size available，superfine model up to 1um","home_product_section_2":"Boron Nitride","home_product_section_2_detail":"Competitive price with high quality, both powders and coating","home_product_section_3":"PVC Stabilizer","home_product_section_3_detail":"Different model available，fast shipment and delivery to worldwide","home_product_section_4":"Calcium Stearate","home_product_section_4_detail":"Professional supplier, fast shipment and delivery to worldwide","home_product_section_5":"Boron nitride coating","home_adv":"Our Advantages","home_adv_section_1":"Factory direct price to low down your costs","home_adv_section_1_detail":"ADA Chemical is a professional manufacture of chemical materials. We have more than 20 years experience in chemical raw material industry. To provide customers with our best quality products and services is always our consistent pursuit. Our factory direct prices will low down your cost and help you to grow your business.","home_adv_section_2":"Professional technical support","home_adv_section_2_detail":"Our technical expert and customer service staff will provide free consulting service, to help you to find the most suitable material for your application, and also consulting service through your testing process.","home_adv_section_3":"Fast shipment and delivery","home_adv_section_3_detail":"We always provide fast delivery and strict quality inspection for every shipment, various packing and OEM service are available upon customer’s requirement, our specialist will also provide professional service for the whole export process.","service_title_1":"Keeping in mind of our 6S concept (Sincere, Speedy, Specialized, Smart, Smiling, Support), our technical expert and customer service staff are always ready to provide our best service to you.","service_title_2":"Here are some frequently asked questions for your reference:","service_q_1":"Can I get a sample?","service_a_1":"Yes, we can provide samples. But please note that you need to pay for the cost by yourself. Our samples will send directly from China, and the international courier cost could be expensive. Our minimum package is usually 500g, and the cost is around 50-100 USD due to different worldwide destination.","service_q_2":"What is the MOQ?","service_a_2":"The MOQ is different for different products, but we are only doing direct whole sale business, for example, for Aluminum Hydroxide and PVC Resin, we usually sell based on container basis. So if you need only small amount, we suggest that you may buy from your local market, because the shipping cost could be expensive.","service_q_3":"About technical support","service_a_3":"We will provide consulting service to help you to find the most suitable material for your application, and also technical support through your whole application process.","service_q_4":"About payment","service_a_4":"We only accept TT bank transfer or LC payment method. Small amount payment for samples can also be paid by PAYPAL.","service_q_5":"About OEM service","service_a_5":"OEM service is available for most of our products, please contact with our sales staff for details.","contact_1":"Sales & Service","contact_tel":"Tel: ","contact_email":"Email: ","contact_fax":"Fax: ","contact_mobile":"Mobile/Wechat: ","contact_2":"Factory Address","contact_empty":"","contact_3":"Shanghai Office","contact_addr_1":"No.2 Bianhe Road, Bianhe Town, Linzi District Zibo City, Shandong, China","contact_addr_2":"Room 1208, No.36, 1200 Changqing Road, Pudong New Area, Shanghai","form_1":"Enter Your Name*","form_2":"Enter Your Email*","form_3":"Your phone or Whatsapp","form_4":"Type your message*","form_submit":"Submit Inquiry","form_submitted":"Thanks for your inquiry, we will reply soon.","product_1":"MF","product_2":"CAS No.","product_3":"Appearance","product_4":"HS Code","product_5":"Chemical name","product_6":"Content","product_7":"Melting Point","product_8":"White Powder","product_9":"White Flake","product_10":"Lead or Ca-Zn","team_1":"We always believe in our staff as the most important core value of the company. After 20 years of development and accumulation, we now have nearly 100 employees, successfully established a professional research development team and also a experienced product line team.","team_2":"We have a good personnel structure, which includes several highly educated technical experts, and a large number of experienced workers at different divisions. In order to develop the good quality product for customers, we also regularly hire and consult industry experts from related colleges, to track the market cutting-edge technology and industry development trend.","partner_1":"Keep in mind the 'win-win cooperation' business philosophy, we actively carry out cooperation with various business partners.","partner_2":"After more than 20 years’ business development, the company has established partnership with Petro china, Sinopec, Chalco and other major chemical groups in China. In order to meet the needs of the overseas market, we also cooperate with some major international freight company, to provide the best service to our customers.","customer_1":"Not only the business in mainland China , we are also actively expanding overseas market, such as southeast Asia, Middle East, North America, and other regions. After years of market development, we successfully established business partnership with some well-known manufacturers, and we are also working closely with small and medium enterprises.","customer_2":"To provide customers with our best quality products and services is always our consistent pursuit."}

/***/ }),

/***/ 1407:
/***/ (function(module, exports) {

module.exports = {"menu_home":"首页","menu_about":"关于我们","menu_about_company":"公司简介","menu_about_team":"员工风采","menu_about_customer":"客户案例","menu_about_partner":"合作伙伴","menu_product":"产品中心","menu_product_1":"氢氧化铝","menu_product_2":"氮化硼","menu_product_3":"PVC助剂","menu_product_4":"其他原材料","menu_service":"专业服务","menu_contact":"联系我们","menu_product_left":"产品目录","left_q_title":"问题解答","left_q_1":"获取样品","left_q_2":"最小起订","left_q_3":"技术支持","left_q_4":"付款方式","left_q_5":"OEM服务","home_title":"欢迎来到爱代化工","home_desc_1":"爱代化工是一家专业的化工原材料生产厂家，公司成立于1995年，生产基地座落于山东淄博，并在上海设有销售和服务中心。","home_desc_2":"公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域，并长期出口东南亚、中东、及欧美的多个国家和地区。","home_view_detail":"查看详情","home_about_section_1":"生产基地","home_about_section_1_detail":"专业化工园区，占地面积10000平方米。","home_about_section_2":"生产设备","home_about_section_2_detail":"多条独立生产线和检测设备，30年化工行业经验。","home_about_section_3":"技术研发","home_about_section_3_detail":"高素质员工队伍，配备全套精密仪器。","home_about_section_4":"销售与服务","home_about_section_4_detail":"优良的产品质量和服务，以满足客户为己任。","home_product":"主要产品","home_product_section_1":"氢氧化铝","home_product_section_1_detail":"","home_product_section_2":"氮化硼","home_product_section_2_detail":"","home_product_section_3":"PVC稳定剂","home_product_section_3_detail":"","home_product_section_4":"硬脂酸钙","home_product_section_4_detail":"","home_product_section_5":"氮化硼涂料","home_adv":"我们的优势","home_adv_section_1":"高性价比产品","home_adv_section_1_detail":"专业生产厂家，超过20年化工原料行业经验。为客户提供最好的产品和服务是我们一贯的追求。我们致力于提供高性价比产品，降低客户的生产成本，帮助客户扩大业务。","home_adv_section_2":"专业技术支持","home_adv_section_2_detail":"我们的技术专家和客户服务人员将提供免费的咨询服务，帮助您找到最合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。","home_adv_section_3":"优质售后服务","home_adv_section_3_detail":"在提供优质产品的同时，我们也高度关注快速交付能力和严格的质量检查。各种包装和OEM服务可按照客户的要求来严格执行。我们的专业团队还将为整个出口过程提供专业服务。","service_title_1":"我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障","service_title_2":"","service_q_1":"关于样品","service_a_1":"根据不同的产品和客户需求，我们可以提供1-5公斤的免费样品","service_q_2":"最小起订量","service_a_2":"大部分产品的最小起订量为1吨。具体请联系我们的销售人员","service_q_3":"技术支持","service_a_3":"我们将提供咨询服务，帮助您找到最适合您申请的材料，并在您的整个申请过程中提供技术支持。","service_q_4":"付款方式","service_a_4":"付款方式一般为款到发货。出口业务，针对不同国家，我们可以接受TT、信用证等不同付款方式。具体请联系我们的销售人员","service_q_5":"OEM服务","service_a_5":"根据客户的行业应用和产品需求，我们可以提供各种定制化的原材料和添加剂。而且，我们也提供各种包装定制和其他相关OEM服务，具体请联系我们的销售人员","contact_1":"销售服务","contact_tel":"电话: ","contact_email":"电子邮箱: ","contact_fax":"传真: ","contact_mobile":"手机/微信: ","contact_2":"工厂地址","contact_empty":"","contact_3":"上海办公室","contact_addr_1":"山东省淄博市临淄区边河镇边河路2号","contact_addr_2":"上海市浦东新区长清路1200弄36号1208","form_1":"请输入您的称呼*","form_2":"请输入您的邮箱*","form_3":"请输入联系电话或其他联系方式","form_4":"请输入您的附言*","form_submit":"提交询盘","form_submitted":"感谢您的询问，我们将尽快回复您的询盘.","product_1":"分子式","product_2":"CAS编号","product_3":"外观","product_4":"HS编码","product_5":"化学名称","product_6":"主要成分","product_7":"熔点","product_8":"白色粉末","product_9":"白色片状粉末","product_10":"铅盐/钙锌","team_1":"我们始终相信员工是公司最重要的核心价值观。经过20年的发展和积累，我们现在拥有近100名员工，成功建立了一支专业的研发团队和一支经验丰富的产品线团队。","team_2":"我们有一个良好的人员结构，包括几位受过高等教育的技术专家，以及大量经验丰富的不同部门的工人。为了为客户开发出优质的产品，我们还定期聘请和咨询相关院校的行业专家，跟踪市场前沿技术和行业发展趋势。","partner_1":"秉承“合作共赢”的经营理念，我们积极与各类商业伙伴开展合作。","partner_2":"经过20多年的业务发展，公司已与中国石油、中石化、中国铝业等国内主要化工集团建立了合作伙伴关系。为了满足海外市场的需求，我们还与一些主要的国际货运公司合作，为我们的客户提供最好的服务。","customer_1":"不仅在中国内地开展业务，我们还积极拓展海外市场，如东南亚、中东、北美等地区。经过多年的市场开发，我们成功地与一些知名制造商建立了业务合作伙伴关系，我们也与中小企业密切合作。","customer_2":"为客户提供最优质的产品和服务是我们一贯的追求。"}

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(629);
module.exports = __webpack_require__(628);


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    url: "https://adaorder.dctechonline.cn/api"
};

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1213)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(924);

var _axios2 = _interopRequireDefault(_axios);

var _App = __webpack_require__(1372);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(960);

var _router2 = _interopRequireDefault(_router);

var _vueI18n = __webpack_require__(1371);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _locale = __webpack_require__(959);

var _locale2 = _interopRequireDefault(_locale);

var _antDesignVue = __webpack_require__(699);

var _antDesignVue2 = _interopRequireDefault(_antDesignVue);

__webpack_require__(1211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$http = _axios2.default;
_vue2.default.config.productionTip = false;

_vue2.default.use(_vueI18n2.default);
_vue2.default.use(_antDesignVue2.default);

var i18n = new _vueI18n2.default({
    locale: 'en',
    messages: _locale2.default });

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "H+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds() };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return fmt;
};

new _vue2.default({
    el: '#app',
    i18n: i18n,
    router: _router2.default,
    template: '<App/>',
    components: { App: _App2.default }
});

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1220)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports = {"name":"ant-design-vue","version":"1.7.6","title":"Ant Design Vue","description":"An enterprise-class UI design language and Vue-based implementation","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"main":"lib/index.js","module":"es/index.js","typings":"types/index.d.ts","files":["dist","lib","es","types","scripts"],"scripts":{"dev":"webpack-dev-server","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js","compile":"node antd-tools/cli/run.js compile","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","prepublish":"node antd-tools/cli/run.js guard","pre-publish":"node ./scripts/prepub","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","codecov":"codecov","postinstall":"node scripts/postinstall || echo \"ignore\""},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"license":"MIT","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"homepage":"https://www.antdv.com/","peerDependencies":{"vue":"^2.6.0","vue-template-compiler":"^2.6.0"},"devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"]}

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navbar = __webpack_require__(1382);

var _navbar2 = _interopRequireDefault(_navbar);

var _bottom = __webpack_require__(1376);

var _bottom2 = _interopRequireDefault(_bottom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},

    computed: {
        showHeaderAndFooter: function showHeaderAndFooter() {
            var path = this.$router.history.current.path;
            return !path.startsWith('/admin');
        }
    },
    mounted: function mounted() {
        var locale = window.localStorage.getItem('locale');
        if (locale != null) {
            this.$i18n.locale = locale;
        }

        console.log(this.$router.history.current.path);
    },

    components: {
        navbar: _navbar2.default,
        bottom: _bottom2.default
    }
};

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(392);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  beforeCreate: function beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },

  methods: {
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log(values);
          var postData = {};
          postData.name = values.userName;
          postData.password = values.password;
          _this.$http.post(_config2.default.url + "/user", postData).then(function (res) {
            if (res.data == null) {
              _this.$message.info('登录失败');
            } else {
              window.localStorage.setItem('token', JSON.stringify(res.data));
              window.localStorage.setItem('role', res.data.role);
              _this.$router.push('/admin/orders');
            }
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(392);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var columns = [{
    dataIndex: 'contractNo',
    key: 'contractNo',
    title: 'PI No.'
}, {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' }
}, {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
}, {
    title: '提单日',
    dataIndex: 'etd',
    key: 'etd'
}, {
    title: '到港日',
    key: 'eta',
    dataIndex: 'eta'
}, {
    title: '国家',
    key: 'region',
    dataIndex: 'region',
    scopedSlots: { customRender: 'region' }
}, {
    title: '客户名称',
    key: 'customer',
    dataIndex: 'customer'
}, {
    title: '销售员',
    key: 'sales',
    dataIndex: 'sales'
}, {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
}, {
    title: '品名',
    key: 'firstProduct',
    scopedSlots: { customRender: 'firstProduct' }
}, {
    title: '数量',
    key: 'firstProductCount',
    scopedSlots: { customRender: 'firstProductCount' }
}, {
    title: '合同金额',
    key: 'productPrice',
    dataIndex: 'productPrice'
}, {
    title: '实收',
    key: 'income',
    dataIndex: 'income'
}, {
    title: '采购汇总',
    key: 'procumentTotal',
    dataIndex: 'procumentTotal'
}, {
    title: '物流汇总',
    key: 'shippingTotal',
    dataIndex: 'shippingTotal'
}, {
    title: '佣金汇总',
    key: 'extraTotal',
    dataIndex: 'extraTotal'
}, {
    title: '其他汇总',
    key: 'otherTotal',
    dataIndex: 'otherTotal'
}];

var otherColumns = [{
    title: '费用说明',
    key: 'feeTitle',
    dataIndex: 'feeTitle',
    scopedSlots: { customRender: 'feeTitle' }
}, {
    title: '费用金额',
    key: 'fee',
    dataIndex: 'fee',
    scopedSlots: { customRender: 'fee' }
}, {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'action' }
}];

var productColumns = [{
    title: '产品名',
    key: 'productName',
    dataIndex: 'productName',
    scopedSlots: { customRender: 'productName' }
}, {
    title: '单价',
    key: 'productPrice',
    dataIndex: 'productPrice',
    scopedSlots: { customRender: 'productPrice' }
}, {
    title: '数量',
    key: 'productCount',
    dataIndex: 'productCount',
    scopedSlots: { customRender: 'productCount' }
}, {
    title: '总量',
    key: 'productTotal',
    dataIndex: 'productTotal',
    scopedSlots: { customRender: 'productTotal' }
}, {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'action' }
}];

var procumentColumns = [{
    title: '产品名',
    key: 'productName',
    dataIndex: 'productName',
    scopedSlots: { customRender: 'productName' }
}, {
    title: '数量',
    key: 'productCount',
    dataIndex: 'productCount',
    scopedSlots: { customRender: 'productCount' }
}, {
    title: '采购单价',
    key: 'procumentPrice',
    dataIndex: 'procumentPrice',
    scopedSlots: { customRender: 'procumentPrice' }
}, {
    title: '采购总价',
    key: 'procumentTotal',
    dataIndex: 'procumentTotal',
    scopedSlots: { customRender: 'procumentTotal' }
}, {
    title: '供应商',
    key: 'supplier',
    dataIndex: 'supplier',
    scopedSlots: { customRender: 'supplier' }
}, {
    title: '去票比率',
    key: 'procumentRatio',
    dataIndex: 'procumentRatio',
    scopedSlots: { customRender: 'procumentRatio' }
}, {
    title: '去票价',
    key: 'procumentAfterPiao',
    dataIndex: 'procumentAfterPiao',
    scopedSlots: { customRender: 'procumentAfterPiao' }
}, {
    title: '最终采购成本',
    key: 'procumentTotalCost',
    dataIndex: 'procumentTotalCost',
    scopedSlots: { customRender: 'procumentTotalCost' }
}, {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'action' }
}];

var shippingColumns = [{
    title: '货代名称',
    key: 'freight',
    dataIndex: 'freight',
    scopedSlots: { customRender: 'freight' }
}, {
    title: '柜子数量',
    key: 'boxCount',
    dataIndex: 'boxCount',
    scopedSlots: { customRender: 'boxCount' }
}, {
    title: '柜子单价',
    key: 'boxPrice',
    dataIndex: 'boxPrice',
    scopedSlots: { customRender: 'boxPrice' }
}, {
    title: '柜子总价',
    key: 'boxTotal',
    dataIndex: 'boxTotal',
    scopedSlots: { customRender: 'boxTotal' }
}, {
    title: '汇率',
    key: 'rate',
    dataIndex: 'rate',
    scopedSlots: { customRender: 'rate' }
}, {
    title: '柜子总价（RMB）',
    key: 'boxTotalRMB',
    dataIndex: 'boxTotalRMB',
    scopedSlots: { customRender: 'boxTotalRMB' }
}, {
    title: '港杂',
    key: 'portCharge',
    dataIndex: 'portCharge',
    scopedSlots: { customRender: 'portCharge' }
}, {
    title: '货代总费用',
    key: 'freightTotal',
    dataIndex: 'freightTotal',
    scopedSlots: { customRender: 'freightTotal' }
}, {
    title: '物流费用',
    key: 'innerShippingFee',
    dataIndex: 'innerShippingFee',
    scopedSlots: { customRender: 'innerShippingFee' }
}, {
    title: '打托费',
    key: 'tollFee',
    dataIndex: 'tollFee',
    scopedSlots: { customRender: 'tollFee' }
}, {
    title: '保险',
    key: 'insurance',
    dataIndex: 'insurance',
    scopedSlots: { customRender: 'insurance' }
}, {
    title: 'DHL费用',
    key: 'dhl',
    dataIndex: 'dhl',
    scopedSlots: { customRender: 'dhl' }
}, {
    title: '其他费用',
    key: 'other',
    dataIndex: 'other',
    scopedSlots: { customRender: 'other' }
}, {
    title: '最终费用',
    key: 'finalShippingCost',
    dataIndex: 'finalShippingCost',
    scopedSlots: { customRender: 'finalShippingCost' }
}, {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'action' }
}];

var bankCostColumns = [{
    title: '实收',
    key: 'actualIncome',
    dataIndex: 'actualIncome',
    scopedSlots: { customRender: 'actualIncome' }
}, {
    title: '实收日期',
    key: 'actualIncomeDate',
    dataIndex: 'actualIncomeDate',
    scopedSlots: { customRender: 'actualIncomeDate' }
}, {
    title: '银行费用（外）',
    key: 'bankFee',
    dataIndex: 'bankFee',
    scopedSlots: { customRender: 'bankFee' }
}, {
    title: '汇率',
    key: 'rate',
    dataIndex: 'rate',
    scopedSlots: { customRender: 'rate' }
}, {
    title: '实收人民币',
    key: 'actualIncomeRMB',
    dataIndex: 'actualIncomeRMB',
    scopedSlots: { customRender: 'actualIncomeRMB' }
}, {
    title: '银行费用（RMB）',
    key: 'bankFeeRMB',
    dataIndex: 'bankFeeRMB',
    scopedSlots: { customRender: 'bankFeeRMB' }
}, {
    title: '收款行',
    key: 'bankName',
    dataIndex: 'bankName',
    scopedSlots: { customRender: 'bankName' }
}, {
    title: '最终实收',
    key: 'finalIncome',
    dataIndex: 'finalIncome',
    scopedSlots: { customRender: 'finalIncome' }
}, {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'action' }
}];

exports.default = {
    data: function data() {
        return {
            total: 0,
            pageNumber: 1,
            pageSize: 10,
            selectedType: '',
            selectedCountry: '',
            selectedCustomer: '',
            selectedFreight: '',
            selectedProductName: '',
            selectedStatus: '',
            selectedPINo: '',
            selectedETD: [],
            selectedETA: [],
            productEditableColumns: ['productName'],
            productNumberColumns: ['productPrice', 'productCount'],
            productFixedColumns: ['productTotal'],
            procumentEditableColumns: ['productName', 'supplier'],
            procumentFixedColumns: ['procumentTotal', 'procumentRefund', 'procumentTotalCost', 'procumentAfterPiao'],
            procumentNumberColumns: ['productCount', 'procumentRatio', 'procumentPrice'],
            shippingEditableColumns: ['freight'],
            shippingFixedColumns: ['boxTotal', 'boxTotalRMB', 'prodcumentTotalCost', 'finalShippingCost', 'freightTotal'],
            shippingNumberColumns: ['boxCount', 'boxPrice', 'rate', 'portCharge', 'innerShippingFee', 'tollFee', 'insurance', 'dhl', 'other'],
            bankcostEditableColumns: ['bankName'],
            bankcostFixedColumns: ['actualIncomeRMB', 'finalIncome', 'bankFee'],
            bankcostNumberColumns: ['actualIncome', 'rate', 'bankFeeRMB'],
            otherEditableColumns: ['feeTitle'],
            otherFixedColumns: [],
            otherNumberColumns: ['fee'],
            order: null,
            mode: 'create',
            config: {},
            createModal: false,
            orders: [],
            data: [],
            products: [],
            productSummaries: null,
            procuments: [],
            shippings: [],
            bankcosts: [],
            others: [],
            columns: [],
            otherColumns: otherColumns,
            productColumns: productColumns,
            procumentColumns: procumentColumns,
            shippingColumns: shippingColumns,
            bankCostColumns: bankCostColumns,
            labelCol: { span: 6 },
            wrapperCol: { span: 12 },
            admin: false,
            summary: null,
            form: {
                orderPre: '',
                orderPost: '',
                orderNo: '',
                region: '',
                customer: '',
                sales: '',
                type: '1',
                brokerage: '',
                status: '1'
            }
        };
    },
    mounted: function mounted() {
        var token = window.localStorage.getItem('token');
        if (token == null) {
            this.$router.push('/admin');
            return;
        }

        var role = window.localStorage.getItem('role');

        if (role != null) {

            if (role == 1) {
                this.columns = columns.slice();
                this.columns.push({
                    title: '美金利润',
                    key: 'dollarProfitTotal',
                    dataIndex: 'dollarProfitTotal',
                    scopedSlots: { customRender: 'dollarProfitTotal' }
                });
                this.columns.push({
                    title: '利润',
                    key: 'profitTotal',
                    dataIndex: 'profitTotal',
                    scopedSlots: { customRender: 'profitTotal' }
                });

                this.columns.push({

                    title: '利润比(%)',
                    key: 'profitRate',
                    dataIndex: 'profitRate'
                });
                this.admin = true;
            } else if (role == 2) {
                this.columns = columns;
            }
        } else {
            this.$router.push('/admin');
            return;
        }
        var pageSize = window.localStorage.getItem('pageSize');
        if (pageSize != null) {
            this.pageSize = parseInt(pageSize);
        }
        this.loadOrders();
        this.loadConfig();
    },

    methods: {
        loadConfig: function loadConfig() {
            var _this = this;

            this.$http.get(_config2.default.url + '/config').then(function (res) {
                _this.config = res.data;
            });
        },
        saveProduct: function saveProduct(record) {
            record.mode = 'normal';
            this.order.products = this.products;
        },
        saveProcument: function saveProcument(record) {
            record.mode = 'normal';
            this.order.procuments = this.procuments;
        },
        saveShipping: function saveShipping(record) {
            record.mode = 'normal';
            this.order.shippings = this.shippings;
        },
        saveBankcost: function saveBankcost(record) {
            record.mode = 'normal';
            this.order.bankcosts = this.bankcosts;
        },
        deleteOrder: function deleteOrder(order) {
            var _this2 = this;

            var result = confirm("删除后无法恢复，确认吗？");
            if (result) {
                var id = order.id;
                this.$http.delete(_config2.default.url + '/order/' + id).then(function (res) {
                    if (res.data.code == 0) {
                        _this2.$message.success('已删除');
                        _this2.pageNumber = 1;
                        _this2.loadOrders();
                    } else {
                        _this2.$message.error('已删除');
                    }
                });
            }
        },
        getProcumentTotal: function getProcumentTotal() {
            if (this.procuments.length == 0) {
                return;
            }
            var total = 0;

            this.procuments.forEach(function (p) {

                total += p.procumentTotalCost;
            });

            return {
                total: total.toFixed(2)
            };
        },
        getProductTotal: function getProductTotal() {
            if (this.products.length == 0) {
                return;
            }

            var count = 0;
            var total = 0;
            this.products.forEach(function (p) {
                count += p.productCount;
                total += p.productTotal;
            });
            return {
                count: count,
                total: total.toFixed(2)
            };
        },
        getShippingTotal: function getShippingTotal() {
            if (this.shippings.length == 0) {
                return;
            }

            var total = 0;
            this.shippings.forEach(function (p) {
                total += p.finalShippingCost;
            });
            return {
                total: total.toFixed(2)
            };
        },
        getBankTotal: function getBankTotal() {
            if (this.bankcosts.length == 0) {
                return;
            }

            var total = 0;
            this.bankcosts.forEach(function (p) {
                total += p.finalIncome;
            });
            return {
                total: total.toFixed(2)
            };
        },
        getOtherTotal: function getOtherTotal() {
            if (this.others.length == 0) {
                return;
            }

            var total = 0;
            this.others.forEach(function (p) {

                total += p.fee;
            });
            return {
                total: total.toFixed(2)
            };
        },
        exportToCSV: function exportToCSV(rows, filename) {
            if (!filename) filename = new Date().toDateString() + '.csv';

            if (!rows || !rows.length) {
                console.log('No data to export');
                return;
            }

            var csvContent = "data:text/csv;charset=utf-8,";

            var headers = Object.keys(rows[0]);
            csvContent += headers.join(",") + "\r\n";
            var that = this;

            rows.forEach(function (rowArray) {
                var row = headers.map(function (fieldName) {
                    return JSON.stringify(rowArray[fieldName], that.replacer);
                }).join(",");
                csvContent += row + "\r\n";
            });

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
        },
        replacer: function replacer(key, value) {
            if (value instanceof Date) {
                return value.toLocaleString();
            }
            return value;
        },
        exportData: function exportData() {
            var _this3 = this;

            var req = {};
            req.start = 0;
            req.size = 100000;
            this.$http.post(_config2.default.url + '/orders', req).then(function (res) {
                var rows = [];
                res.data.list.forEach(function (o) {
                    var obj = {};
                    obj.PiNo = o.PiNo;
                    obj.contractNo = o.contractNo && o.contractNo != null && o.contractNo != '' ? o.contractNo : o.PiNo;
                    obj.customer = o.customer;
                    obj.sales = o.sales;
                    obj.type = o.type;
                    obj.region = o.region;
                    obj.brokerage = o.brokerage;

                    obj.status = o.status ? o.status : '1';

                    obj.procumentTotal = parseFloat(o.procumentTotal).toFixed(2);
                    obj.profitTotal = parseFloat(o.profitTotal).toFixed(2);
                    obj.shippingTotal = o.shippingTotal;
                    obj.profitRate = o.profitRate;
                    obj.extraTotal = o.brokerage;
                    obj.otherTotal = o.otherTotal;
                    obj.income = parseFloat(o.income).toFixed(2);
                    obj.brokerageTotal = parseFloat(o.brokerageTotal).toFixed(2);
                    obj.productPrice = parseFloat(o.productPrice).toFixed(2);

                    if (o.eta && o.eta != '') {
                        obj.eta = new Date(o.eta).format('MM.dd');
                    }

                    if (o.etd && o.etd != '') {
                        obj.etd = new Date(o.etd).format('MM.dd');
                    }

                    rows.push(obj);
                });

                _this3.exportToCSV(rows);
            });
        },
        handleProcumentChange: function handleProcumentChange(value, key, column) {
            var newData = [].concat(_toConsumableArray(this.procuments));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            if (target) {
                target[column] = value;
                target['procumentTotal'] = target['productCount'] * target['procumentPrice'];
                target['procumentAfterPiao'] = target['procumentPrice'] * (1 - target['procumentRatio']);
                target['procumentTotalCost'] = target['procumentAfterPiao'] * target['productCount'];
                this.procuments = newData;
            }
        },
        onPageChange: function onPageChange(page, pageSize) {
            this.pageNumber = page;
            this.loadOrders();
        },
        deleteProduct: function deleteProduct(index) {
            this.products.splice(index, 1);
        },
        deleteProcument: function deleteProcument(index) {
            this.procuments.splice(index, 1);
        },
        deleteShipping: function deleteShipping(index) {
            this.shippings.splice(index, 1);
        },
        deleteBankcost: function deleteBankcost(index) {
            this.bankcosts.splice(index, 1);
        },
        deleteOther: function deleteOther(index) {
            this.others.splice(index, 1);
        },
        getSummary: function getSummary() {
            return {
                total: 0,
                count: 0
            };
        },
        handleShippingChange: function handleShippingChange(value, key, column) {
            var newData = [].concat(_toConsumableArray(this.shippings));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            if (target) {
                target[column] = value;
                target['boxTotal'] = target['boxPrice'] * target['boxCount'];
                target['boxTotalRMB'] = target['boxTotal'] * target['rate'];
                target['freightTotal'] = target['boxTotalRMB'] + target['portCharge'];
                target['finalShippingCost'] = target['freightTotal'] + target['tollFee'] + target['innerShippingFee'] + target['insurance'];
                if (target['dhl']) {
                    target['finalShippingCost'] += target['dhl'];
                }
                if (target['other']) {
                    target['finalShippingCost'] += target['other'];
                }
                this.shippings = newData;
            }
        },
        handleBankcostChange: function handleBankcostChange(value, key, column) {
            var newData = [].concat(_toConsumableArray(this.bankcosts));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            if (target) {
                target[column] = value;
                var total = 0;
                this.products.forEach(function (p) {
                    total += p.productTotal;
                });

                target["bankFee"] = total - target["actualIncome"];
                target["actualIncomeRMB"] = target["actualIncome"] * target["rate"];
                target["finalIncome"] = target["actualIncomeRMB"] - target["bankFeeRMB"];
                this.bankcosts = newData;
            }
        },
        handleOtherChange: function handleOtherChange(value, key, column) {
            var newData = [].concat(_toConsumableArray(this.others));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            if (target) {
                target[column] = value;

                this.others = newData;
            }
        },
        handleDateChange: function handleDateChange(value, key) {
            var newData = [].concat(_toConsumableArray(this.bankcosts));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            target['actualIncomeDate'] = value;
            this.bankcosts = newData;
        },
        handleProductChange: function handleProductChange(value, key, column) {
            var newData = [].concat(_toConsumableArray(this.products));
            var target = newData.find(function (item) {
                return key === item.key;
            });
            if (target) {
                target[column] = value;
                target['productTotal'] = target['productPrice'] * target['productCount'];
                this.products = newData;
            }
        },
        handleProductNameChange: function handleProductNameChange(e) {
            this.selectedProductName = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handlePINoChange: function handlePINoChange(e) {
            this.selectedPINo = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleTypeChange: function handleTypeChange(e) {
            this.type = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleCountryChange: function handleCountryChange(e) {
            this.selectedCountry = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleStatusChange: function handleStatusChange(e) {
            this.selectedStatus = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleCustomerChange: function handleCustomerChange(e) {
            this.selectedCustomer = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleFreightChange: function handleFreightChange(e) {
            this.selectedFreight = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        onETDChange: function onETDChange(e) {
            this.selectedETD = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        onETAChange: function onETAChange(e) {
            this.selectedETA = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        changePageSize: function changePageSize(e) {
            this.pageSize = parseInt(e);
            window.localStorage.setItem('pageSize', this.pageSize);
            this.pageNumber = 1;
            this.loadOrders();
        },
        resetFilter: function resetFilter() {
            this.selectedCountry = "";
            this.selectedETA = [];
            this.selectedETD = [];
            this.selectedType = "";
            this.selectedCustomer = "";
            this.selectedProductName = "";
            this.selectedFreight = "";
            this.pageNumber = 1;
            this.loadOrders();
        },
        loadOrders: function loadOrders() {
            var _this4 = this;

            var req = {};
            req.start = (this.pageNumber - 1) * this.pageSize;
            req.size = this.pageSize;
            if (this.selectedCountry != '') {
                req.region = this.selectedCountry;
            }
            if (this.selectedType != '') {
                req.type = this.selectedType;
            }
            if (this.selectedPINo != '') {
                req.Pi = this.selectedPINo;
            }
            if (this.selectedETA.length == 2) {
                req.eta = [this.selectedETA[0].format('yyyy-MM-DD'), this.selectedETA[1].format('yyyy-MM-DD')];
            }
            if (this.selectedETD.length == 2) {
                req.etd = [this.selectedETD[0].format('yyyy-MM-DD'), this.selectedETD[1].format('yyyy-MM-DD')];
            }
            if (this.selectedCustomer != '') {
                req.customer = this.selectedCustomer;
            }
            if (this.selectedFreight != '') {
                req.freight = this.selectedFreight;
            }
            if (this.selectedProductName != '') {
                req.product = this.selectedProductName;
            }
            if (this.selectedStatus != '') {
                req.status = this.selectedStatus;
            }

            this.$http.post(_config2.default.url + '/orders', req).then(function (res) {
                _this4.orders = res.data;
                _this4.summary = res.data.summary;

                _this4.data = [];
                _this4.orders.list.forEach(function (o) {
                    var obj = {};
                    obj.PiNo = o.PiNo;
                    obj.contractNo = o.contractNo && o.contractNo != null && o.contractNo != '' ? o.contractNo : o.PiNo;
                    obj.customer = o.customer;
                    obj.sales = o.sales;
                    obj.type = o.type;
                    obj.region = o.region;
                    obj.brokerage = o.brokerage;
                    obj.id = o.id;
                    obj.key = o.id;
                    obj.products = o.products;
                    obj.status = o.status ? o.status : '1';
                    obj.others = o.others;
                    obj.shippings = o.shippings;
                    obj.bankcosts = o.bankcosts;
                    obj.procuments = o.procuments;
                    obj.procumentTotal = parseFloat(o.procumentTotal).toFixed(2);
                    obj.profitTotal = parseFloat(o.profitTotal).toFixed(2);
                    obj.shippingTotal = parseFloat(o.shippingTotal).toFixed(2);
                    obj.profitRate = o.profitRate;
                    obj.extraTotal = o.brokerage;
                    obj.otherTotal = o.otherTotal;
                    obj.income = parseFloat(o.income).toFixed(2);
                    obj.brokerageTotal = parseFloat(o.brokerageTotal).toFixed(2);
                    obj.productPrice = parseFloat(o.productPrice).toFixed(2);

                    if (o.eta && o.eta != '') {
                        obj.etaObj = o.eta;
                        obj.eta = new Date(o.eta).format('MM.dd');
                    }

                    if (o.etd && o.etd != '') {
                        obj.etdObj = o.etd;
                        obj.etd = new Date(o.etd).format('MM.dd');
                    }

                    _this4.data.push(obj);
                });
                _this4.total = _this4.orders.total;
            });
        },
        edit: function edit(row) {
            this.mode = 'edit';
            this.form.type = row.type;
            this.form.region = row.region;
            this.form.sales = row.sales;
            if (row.etd && row.etd != '') {
                this.form.etd = (0, _moment2.default)(row.etdObj);
            } else {
                this.form.etd = '';
            }
            if (row.eta && row.eta != '') {
                this.form.eta = (0, _moment2.default)(row.etaObj);
            } else {
                this.form.eta = '';
            }
            this.form.customer = row.customer;
            this.form.PiNo = row.PiNo;
            this.form.id = row.id;
            this.form.status = row.status;
            this.form.brokerage = row.brokerage;
            this.order = row;
            this.products = row.products;
            this.productSummaries = {
                productCount: 20,
                productName: '合计',
                productPrice: ''
            };

            this.procuments = row.procuments;
            this.shippings = row.shippings;
            if (row.others) {
                this.others = row.others;
            } else {
                this.others = [];
            }
            this.bankcosts = row.bankcosts;
            var no = row.contractNo && row.contractNo != null && row.contractNo != '' ? row.contractNo : row.PiNo;
            this.form.orderPre = no.substring(0, 5);
            this.form.orderPost = row.region + row.customer[0] + row.sales[0];
            this.form.orderNo = no.substring(5).replace(this.form.orderPost, '');
            this.createModal = true;
        },
        addProduct: function addProduct() {
            this.products.push({
                key: this.products.length + 1,
                productCount: 1,
                productName: "",
                productPrice: 0,
                productTotal: 0,
                mode: 'edit'
            });

            this.$forceUpdate();
        },
        addProcument: function addProcument() {
            this.procuments.push({
                key: this.procuments.length + 1,
                productCount: 1,
                productName: "",
                supplier: "",
                procumentPrice: 0,
                procumentRatio: 0.115,
                procumentAfterPiao: 0,
                procumentTotal: 0,
                procumentRefund: 0,
                procumentTotalCost: 0,
                mode: 'edit'
            });

            this.$forceUpdate();
        },
        addShipping: function addShipping() {
            this.shippings.push({
                key: this.shippings.length + 1,
                boxCount: 1,
                boxPrice: 0,
                boxTotal: 0,
                rate: this.form.type == '2' ? 7 : 1,
                boxTotalRMB: 0,
                portCharge: 0,
                freightTotal: 0,
                freight: '',
                innerShippingFee: 0,
                tollFee: 0,
                insurance: 0,
                finalShippingCost: 0,
                dhl: 0,
                other: 0,
                mode: 'edit'
            });
        },
        addBankcost: function addBankcost() {
            this.bankcosts.push({
                key: this.bankcosts.length + 1,
                actualIncome: 0,
                actualIncomeDate: '',
                bankFee: 0,
                rate: this.form.type == '2' ? 7 : 1,
                actualIncomeRMB: 0,
                bankFeeRMB: 0,
                finalIncome: 0,
                mode: 'edit'
            });
        },
        addOther: function addOther() {
            this.others.push({
                feeTitle: '',
                fee: 0,
                mode: 'edit'
            });
        },
        submitCreateModal: function submitCreateModal() {
            var _this5 = this;

            if (this.form.region == '' || this.form.sales == '' || this.form.customer == '') {
                this.$message.error('客户名称，国家地区，销售人员为必填项');
                return;
            }

            var postData = {};
            postData.customer = this.form.customer;
            postData.sales = this.form.sales;
            postData.type = this.form.type;
            postData.region = this.form.region;
            postData.etd = this.form.etd;
            postData.eta = this.form.eta;
            postData.products = this.products;
            postData.others = this.others;
            postData.status = this.form.status;
            postData.brokerage = this.form.brokerage;
            postData.procuments = this.procuments;
            postData.bankcosts = this.bankcosts;
            postData.shippings = this.shippings;
            postData.PiNo = this.form.PiNo;
            postData.orderNo = this.form.orderNo;
            postData.contractNo = this.form.orderPre + this.form.orderNo + this.form.orderPost;
            postData.productPrice = 0;
            this.products.forEach(function (p) {
                postData.productPrice += p.productTotal;
            });

            postData.income = 0;
            this.bankcosts.forEach(function (p) {
                postData.income += p.finalIncome;
            });

            postData.brokerageTotal = 0;
            var calRate = null;
            this.bankcosts.forEach(function (b) {
                postData.brokerageTotal += b.bankFee * b.rate + b.bankFeeRMB;
                calRate = b.rate;
            });

            var thisRate = 1;

            if (this.form.type == 2) {
                thisRate = 7.1;
            }

            if (this.bankcosts.length > 0) {
                thisRate = parseFloat(this.bankcosts[0].rate);
            }
            postData.shippingTotal = 0;
            this.shippings.forEach(function (s) {
                postData.shippingTotal += s.finalShippingCost;
            });

            postData.procumentTotal = 0;
            this.procuments.forEach(function (p) {
                postData.procumentTotal += p.procumentTotalCost;
            });

            postData.otherTotal = 0;
            if (this.others && this.others != null) {
                this.others.forEach(function (o) {
                    postData.otherTotal += o.fee;
                });
            }
            postData.brokerage = 0;
            if (this.form.brokerage && this.form.brokerage != '') {
                postData.brokerage = parseFloat(this.form.brokerage);
            }

            postData.profitTotal = 0;
            if (postData.income != 0) {
                postData.profitTotal = postData.income - postData.procumentTotal - postData.shippingTotal - postData.brokerage * thisRate - postData.otherTotal;
            }
            postData.profitRate = 0;

            if (postData.productPrice != 0) {
                if (calRate != null) {
                    postData.profitRate = (postData.profitTotal * 100.0 / (postData.productPrice * calRate)).toFixed(2);
                }
            }

            if (this.order != null) {
                postData.id = this.order.id;
            }
            this.$http.post(_config2.default.url + '/order', postData).then(function (res) {
                _this5.createModal = false;
                _this5.order = null;
                _this5.loadOrders();
            });
        },
        createOrder: function createOrder() {
            this.mode = 'create';
            this.form.type = '2';
            this.form.orderNo = '';
            this.form.orderPre = '';
            this.form.orderPost = '';
            this.form.region = '';
            this.form.sales = '';
            this.form.etd = '';
            this.form.eta = '';
            this.form.status = '1';
            this.form.customer = '';
            this.form.PiNo = '';
            this.form.brokerage = '';
            this.products = [];
            this.procuments = [];
            this.shippings = [];
            this.bankcosts = [];
            this.others = [];
            this.order = {};
            this.createModal = true;
        }
    }
};

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump: function jump(url) {
            $(window).scrollTop(0);
            this.$router.push('category?id=' + url);

            _bus2.default.$emit('changecategory');
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        this.resetCategory();
        _bus2.default.$on('changecategory', function () {
            _this.resetCategory();
        });
    },

    components: {
        left: _left2.default
    },

    data: function data() {
        return {
            category: "1",
            categoryName: "Aluminium Hydroxide"
        };
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        },
        jumpProduct: function jumpProduct(id) {
            this.$router.push('product?id=' + id);
            _bus2.default.$emit('changeproduct');
        },
        resetCategory: function resetCategory() {
            var id = this.getSearchString('id');
            if (id == "2") {
                this.categoryName = "Boron Nitride";
            } else if (id == "3") {
                this.categoryName = "PVC Materials";
            } else if (id == "4") {
                this.categoryName = "Raw Materials";
            } else if (id == "5") {
                this.categoryName = "Food Additives";
            }

            this.category = id;
        },
        getSearchString: function getSearchString(key) {
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);

            var arr = str.split("&");
            var obj = new Object();

            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        }
    }
};

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    created: function created() {},
    mounted: function mounted() {
        var url = "https://adabk2.chinacloudsites.cn/api/email";
        this.$http.get(url).then(function (res) {});
    },

    props: ["productName"],
    components: {},
    methods: {
        closeMask: function closeMask() {
            $("#mask").css("display", "none");
            this.clear();
            $(window).scrollTop(0);
        },
        clear: function clear() {
            this.name = "";
            this.content = "";
            this.email = "";
            this.phone = "";
        },
        submitForm: function submitForm() {
            var _this = this;

            var name = this.name;
            var content = this.content;
            var email = this.email;
            var phone = this.phone;

            var hasError = false;
            if (name == "") {
                $("#name").addClass("error");
                hasError = true;
            } else {
                $("#name").removeClass("error");
            }

            if (email == "") {
                $("#email").addClass("error");
                hasError = true;
            } else {
                $("#email").removeClass("error");
            }

            if (content == "") {
                $("#content").addClass("error");
                hasError = true;
            } else {
                $("#content").removeClass("error");
            }

            if (hasError) {
                this.error = "Please input correct information.";
            } else {

                if (email.indexOf('@') < 0) {
                    this.error = "Email format is not correct.";
                    $("#email").addClass("error");
                    return;
                } else {
                    $("#email").removeClass("error");
                }

                this.error = "";

                var postInfo = {};
                if (!this.productName) {
                    postInfo.title = "Product Inquiry";
                } else {
                    postInfo.title = "Product Inquiry: " + this.productName;
                }
                postInfo.name = name;
                postInfo.email = email;
                postInfo.phone = phone;
                postInfo.content = content;
                postInfo.all = postInfo.title + "   " + postInfo.name + "   " + postInfo.email + "    " + postInfo.phone + "    " + postInfo.content;

                $("#mask").css("display", "block");

                var url = "https://www.dctechonline.cn:8018/api/email/v2";
                this.$http.post(url, postInfo).then(function (res) {
                    _this.clear();
                    $(window).scrollTop(0);

                    var enhanced_conversion_data;
                    enhanced_conversion_data = { "email": email };
                    gtag('event', 'conversion', { 'send_to': 'AW-851371510/GuVqCM3fh8ADENDvqrMo' });
                });

                url = "https://adabk2.chinacloudsites.cn/api/email";
                this.$http.post(url, postInfo).then(function (res) {});

                var _window = window,
                    aplus_queue = _window.aplus_queue;


                aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['adainquiry', 'CLK', postInfo]
                });
            }
        }
    },
    data: function data() {
        return {
            error: "",
            name: "",
            email: "",
            phone: "",
            content: ""
        };
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

var _contact = __webpack_require__(627);

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default,
        contact: _contact2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            authroized: false,
            list: [],
            list2: [],
            password: ""
        };
    },
    mounted: function mounted() {},

    methods: {
        viewList: function viewList() {
            var _this = this;

            if (this.password == "") {
                alert("Please input the password");
                return;
            }
            this.$http.get("https://www.dctechonline.cn:8018/api/email/auth/" + this.password).then(function (res) {
                if ("OK" == res.data) {
                    _this.authroized = true;
                    _this.loadEmails();
                } else {
                    alert('Error password');
                }
            });
        },
        loadEmails: function loadEmails() {
            var _this2 = this;

            this.$http.get("https://www.dctechonline.cn:8018/api/email").then(function (res) {
                console.log(res.data);
                _this2.list = res.data;
            });

            this.$http.get("https://adabk2.chinacloudsites.cn/api/email").then(function (res) {
                console.log(res.data);
                _this2.list2 = res.data;
            });
        }
    }
};

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {
        document.getElementById("video").addEventListener("canplaythrough", function () {});
    },

    components: {},
    methods: {
        gotoUrl: function gotoUrl(url) {
            $(window).scrollTop(0);
            this.$router.push(url);
        },
        jump: function jump(id) {
            $(window).scrollTop(0);
            this.$router.push('product?id=' + id);
            _bus2.default.$emit('changeproduct');
        },
        canplay: function canplay() {
            console.log('play');
        }
    },
    data: function data() {
        return {};
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump1: function jump1() {
            $(window).scrollTop(0);
            this.$router.push('service');
        },
        jump: function jump(url) {

            this.$router.push('category?id=' + url);

            _bus2.default.$emit('changecategory');
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump: function jump(url) {
            this.$router.push(url);
        },
        jump1: function jump1(cate) {
            this.$router.push('category?id=' + cate);
            _bus2.default.$emit('changecategory');
        },
        changeLocale: function changeLocale(locale) {
            this.$i18n.locale = locale;
            window.localStorage.setItem('locale', locale);
        }
    },
    data: function data() {
        return {};
    }
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

var _contact = __webpack_require__(627);

var _contact2 = _interopRequireDefault(_contact);

var _bus = __webpack_require__(97);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            name: "Aluminum Hydroxide",
            id: ""
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        this.resetProduct();

        _bus2.default.$on('changeproduct', function () {
            _this.resetProduct();
        });
    },

    methods: {
        resetProduct: function resetProduct() {
            var id = this.getSearchString("id");
            this.id = id;

            if (id == '114') {
                this.name = this.$t('home_product_section_1');
            } else if (id == '118') {
                this.name = "PVC Resin";
            } else if (id == '115') {
                this.name = this.$t('home_product_section_2');
            } else if (id == '1151') {
                this.name = "Boron Nitride";
            } else if (id == '117') {
                this.name = "Purified Terephthalic Acid";
            } else if (id == '69') {
                this.name = "Sodium Acid Pyrophosphate SAPP";
            } else if (id == '107') {
                this.name = "Boron nitride coating";
            } else if (id == '70') {
                this.name = "Dicyandiamide";
            } else if (id == '106') {
                this.name = "Silicon carbide abrasive";
            } else if (id == '108') {
                this.name = "Fumed Silica";
            } else if (id == '79') {
                this.name = "Poly Aluminium Chloride (PAC)";
            } else if (id == '56') {
                this.name = "Magnesium hydroxide";
            } else if (id == '66') {
                this.name = "Barium Sulfate";
            } else if (id == '661') {
                this.name = "Barium Sulfate";
            } else if (id == '57') {
                this.name = this.$t('home_product_section_3');
            } else if (id == '571') {
                this.name = "PVC Stabilizer";
            } else if (id == '59') {
                this.name = "CPE 135A";
            } else if (id == '60') {
                this.name = "PE wax";
            } else if (id == '61') {
                this.name = "Calcium Stearate";
            } else if (id == '63') {
                this.name = "ACR";
            } else if (id == '71') {
                this.name = "Optical brightener";
            } else if (id == '96') {
                this.name = "Nano calcium carbonate";
            }
        },
        getSearchString: function getSearchString(key) {
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);

            var arr = str.split("&");
            var obj = new Object();

            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
        gotoHome: function gotoHome() {
            this.$router.push('/');
        },
        submitForm: function submitForm() {
            var name = this.name;
            var email = this.email;
            var phone = this.phone;
            var content = this.content;
        }
    },
    components: {
        left: _left2.default,
        contact: _contact2.default
    }
};

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(1406);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(1407);

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    en: _en2.default,
    zh: _zh2.default
};

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1404);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(1381);

var _index2 = _interopRequireDefault(_index);

var _product = __webpack_require__(1384);

var _product2 = _interopRequireDefault(_product);

var _service = __webpack_require__(1385);

var _service2 = _interopRequireDefault(_service);

var _aboutus = __webpack_require__(1373);

var _aboutus2 = _interopRequireDefault(_aboutus);

var _contactus = __webpack_require__(1378);

var _contactus2 = _interopRequireDefault(_contactus);

var _team = __webpack_require__(1386);

var _team2 = _interopRequireDefault(_team);

var _partner = __webpack_require__(1383);

var _partner2 = _interopRequireDefault(_partner);

var _customer = __webpack_require__(1379);

var _customer2 = _interopRequireDefault(_customer);

var _category = __webpack_require__(1377);

var _category2 = _interopRequireDefault(_category);

var _emails = __webpack_require__(1380);

var _emails2 = _interopRequireDefault(_emails);

var _login = __webpack_require__(1374);

var _login2 = _interopRequireDefault(_login);

var _orders = __webpack_require__(1375);

var _orders2 = _interopRequireDefault(_orders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/',
        component: _index2.default
    }, {
        path: '/product',
        component: _product2.default
    }, {
        path: '/service',
        component: _service2.default
    }, {
        path: '/aboutus',
        component: _aboutus2.default
    }, {
        path: '/contactus',
        component: _contactus2.default
    }, {
        path: '/team',
        component: _team2.default
    }, {
        path: '/partner',
        component: _partner2.default
    }, {
        path: '/customer',
        component: _customer2.default
    }, {
        path: '/category',
        component: _category2.default
    }, {
        path: '/emails',
        component: _emails2.default
    }, {
        path: '/admin',
        component: _login2.default
    }, {
        path: '/admin/orders',
        component: _orders2.default
    }]
});

router.beforeEach(function (to, from, next) {
    $(window).scrollTop(0);
    if ($("#navbarCollapse").css("display") == "block") {
        $("#menuButton").click();
    }
    next();
});

exports.default = router;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ })

},[1408]);


// WEBPACK FOOTER //
// static/js/app.3ca1efe08476f4a5c23b.js